import React, { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import {
  Tab,
  Tabs,
  Form,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  Row,
  Col,
  Popover,
} from "react-bootstrap";
import Select from "react-select";
import RetreatRoastApi from "../../../api/retreatRoasterApi";
import AuthApi from "../../../api/authApi";
import RolesApi from "../../../api/RolesApi";
import ServiceApi from "../../../api/ServiceApi";
import TalksApi from "../../../api/TalksApi";
import CommitteeApi from "../../../api/committeeApi";
import FileUploadModal from "../../../components/FileUploadModal";
import { toast } from "react-toastify";
import CustomDataTable from "../../../components/CustomDataTable";
import Helpers from "../../../components/Helpers";
import DeleteModel from "../../../components/DeleteModel";
import AdminApi from "../../../api/admin";
import RetreatApi from "../../../api/retreatApi";
import DirectoryApi from "../../../api/directoryApi";
import SendFileModal from "../../../components/SendFileModal";
import { Cookies, useCookies } from "react-cookie";
import { utils, writeFile } from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment-timezone";
import Container from "react-bootstrap/Container";
import DatePicker from "../../../components/AppDatePicker";
import Profile from "../../../assets/images/couple-default.png";
import corruptedImg from "../../../assets/images/corrupted-img.png";
import UpdateCouplePopUp from "../../common/UpdateCouplePopUp";
import Confirmations from "../../../components/Confirmations";
import AlertModal from "../../../components/AlertModel";
import OtherParishModal from "../../../components/OtherParishModal";
import AssignTalkModal from "../../../components/AssignTalkModal";
import RosterFilterActionModal from "../../../components/RosterFilterActionModal";
import CopyIcon from "../../../components/CopyIcon";
import CopyEmailsButton from "../../../components/CopyEmailsButton";
import { formatParishOptionLabel } from "../../../utils/parishLabels";
import { formatCoupleOptionLabel } from "../../../utils/coupleLabels";
import CreateRetreatSubAdmin from "../../../components/createRetreatSubAdmin";
import PhoneInput from "../../../components/PhoneInput";
import CopyableInput from "../../../components/CopyableInput";
import "../../../assets/css/retreatRoster.css";
import "../../../assets/css/coupleFormModal.css";
import { useTrainingGuide } from "../../../components/AdminTrainingGuide";
import {
  ArrowLeft,
  CalendarDays,
  ChevronDown,
  Church,
  ClipboardList,
  Download,
  FileText,
  Heart,
  Mail,
  MapPin,
  Megaphone,
  Mic2,
  Pencil,
  Phone,
  Search,
  Upload,
  UserPlus,
  Users,
  X,
} from "lucide-react";
import "../../../assets/css/rosterActionModals.css";

const XLSX = require("xlsx");

const directorText = (value) => {
  const text = value == null ? "" : String(value).trim();
  if (!text) {
    return <em className="ram-director-empty-value">Not provided</em>;
  }
  return text;
};

const DirectorField = ({ label, children, wide = false }) => (
  <div className={`ram-director-field${wide ? " is-wide" : ""}`}>
    <span className="ram-director-label">{label}</span>
    <strong>{children}</strong>
  </div>
);

const ROSTER_MISSING_LABEL = "⚠ Missing";

const isRosterBlank = (value) => {
  if (value === null || value === undefined) return true;
  const text = String(value).trim();
  return text === "" || text.toLowerCase() === "null";
};

const ROSTER_REQUIRED_FIELDS = [
  "attendeeType",
  "hisFirstName",
  "hisLastName",
  "herFirstName",
  "herLastName",
  "hisEmail",
  "herEmail",
  "hisMobile",
  "herMobile",
  "city",
  "state",
  "zip",
  "address",
  "anniversary_date",
  "allergies",
];

const MENTOR_COMMON_FIELDS = [
  "attendeeType",
  "city",
  "state",
  "zip",
  "address",
  "allergies",
];

const ROSTER_TABLE_FIELDS = {
  Retreatant: "attendeeType",
  "his Last Name": "hisLastName",
  "his First Name": "hisFirstName",
  "Her Last Name": "herLastName",
  "her First Name": "herFirstName",
  "His Email": "hisEmail",
  "Her Email": "herEmail",
  "His Mobile": "hisMobile",
  "Her Mobile": "herMobile",
  Address: "address",
  Parish: "parish",
  city: "city",
  state: "state",
  zip: "zip",
  "Anniversary Date": "anniversary_date",
};

const isRosterImageMissing = (item) => isRosterBlank(item?.imageUrl);

const rowMissingRosterData = (item) => {
  const hasEmergencyContact1 =
    item.emergency_name1 &&
    item.emergency_phone1 &&
    item.emergency_relationship1;
  const hasEmergencyContact2 =
    item.emergency_name2 &&
    item.emergency_phone2 &&
    item.emergency_relationship2;
  const missingEmergencyContact =
    !hasEmergencyContact1 && !hasEmergencyContact2;

  let missingRequiredField = false;
  if (item.mainRole === "Spiritual Mentor") {
    const hasHis = item.hisFirstName && item.hisEmail && item.hisMobile;
    const hasHer = item.herFirstName && item.herEmail && item.herMobile;
    const missingCommonField = MENTOR_COMMON_FIELDS.some((field) =>
      isRosterBlank(item[field]),
    );
    missingRequiredField = !(hasHis || hasHer) || missingCommonField;
  } else {
    missingRequiredField = ROSTER_REQUIRED_FIELDS.some((field) =>
      isRosterBlank(item[field]),
    );
  }

  return missingRequiredField || missingEmergencyContact;
};

const rowMissingRosterRecord = (item) =>
  rowMissingRosterData(item) || isRosterImageMissing(item);

const isRosterCellMissing = (row, field, retreatParishId) => {
  if (!row || !field) return false;
  if (field === "parish") {
    const hasCoupleParish =
      !isRosterBlank(row.parish) || !isRosterBlank(row.parishId);
    return !hasCoupleParish && isRosterBlank(retreatParishId);
  }
  if (field === "anniversary_date") {
    if (row.mainRole === "Spiritual Mentor") return false;
    return isRosterBlank(row.anniversary_date);
  }
  return isRosterBlank(row[field]);
};

const isFlagOn = (value) =>
  value === true || value === 1 || value === "1" || value === "true";

const parseConfirmationList = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }
  return [];
};

const confirmationFlag = (retreat, key) => {
  if (isFlagOn(retreat?.confirmedByAdmin)) return true;
  const confirmation = parseConfirmationList(retreat?.confirmation);
  const entry = confirmation.find(
    (item) => item && Object.prototype.hasOwnProperty.call(item, key),
  );
  return isFlagOn(entry?.[key]);
};

const RetreatRoaster = () => {
  let cookies = new Cookies();
  let userData = cookies.get("LoveStrongUser") || null;
  let adminApi = new AdminApi();
  let retreatRoastApi = new RetreatRoastApi();
  let retreatApi = new RetreatApi();
  let committeeApi = new CommitteeApi();
  let directoryApi = new DirectoryApi();
  let navigate = useNavigate();
  const training = useTrainingGuide();
  const [cookie, setCookie] = useCookies(["LoveStrongUser"]);
  const [retreatRoastData, setRetreatRoastData] = useState([]);
  const [allRoasters, setAllRoasters] = useState([]);
  const [retreatRoastLeadData, setRetreatRoastLeadData] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [uploadModalTitle, setUploadModalTitle] = useState("");
  const [filterActionModal, setFilterActionModal] = useState({
    open: false,
    filterType: null,
    label: "",
  });
  const [existingFileUrl, setExistingFileUrl] = useState("");
  const [total, setTotal] = useState(20);
  const [LoadData, setLoadData] = useState(false);
  const fetchingCount = useRef(0);
  const retreatDetailRequestId = useRef(0);

  const startLoading = () => {
    fetchingCount.current++;
    setLoadData(true);
  };

  const stopLoading = () => {
    fetchingCount.current--;
    if (fetchingCount.current <= 0) {
      fetchingCount.current = 0;
      setLoadData(false);
    }
  };
  const [totalRoast, setTotalRoast] = useState(10);
  let [searchParams, setSearchParams] = useSearchParams();
  const [searchKey, setSearchKey] = useState(""); //for searching
  const [checklistOpen, setChecklistOpen] = useState(true);
  const [retreatDetail, setRetreatDetail] = useState("");
  let retreatId = searchParams.get("retreatId");
  let isTemp = searchParams.get("isTemp") === "true";
  let flag = searchParams.get("flag");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [service_count, Setservice_count] = useState("");
  const [fileType, setFileType] = useState("");
  const [talk_count, Settalk_count] = useState("");
  const [team_count, SetTeam_count] = useState("");
  const [ret_count, Setret_count] = useState("");

  const isRestrictedUser =
    userData?.userRole !== "ADMIN" &&
    (userData?.committeeMember === true ||
      (userData?.access === true && userData?.isDisabled === 0));
  const isRetreatClosed = retreatDetail
    ? Boolean(retreatDetail.retreatCloseStatus)
    : true;
  const shouldHideUI = isRestrictedUser && isRetreatClosed;
  const [roast_id, setRoast_id] = useState("");
  const [spritual_count, setSpritual_count] = useState(0);
  const [spritualDirector_count, setSpritualDirector_count] = useState(0);
  const [lead_count, setLead_count] = useState(0);
  const [rtp_count, setRtp_count] = useState(0);
  const [emailErrors, setEmailErrors] = useState({});
  const [showRegModal, setShowREgModal] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [ediUserIdClicked, setEdiUserIdClicked] = useState("");
  const [isEditAdmin, setIsEditAdmin] = useState(false);
  const [allCoupleList, setAllCoupleList] = useState([]);
  const [roastersOfCoupleList, setRoastersOfCoupleList] = useState([]);
  const [isNewCouple, setIsNewCouple] = useState(false);
  const [coupleEntryMode, setCoupleEntryMode] = useState("new");
  const [existingCoupleOption, setExistingCoupleOption] = useState(null);
  const [roasterCount, setRoasterCount] = useState(0);

  const [statusCheck, setStatusCheck] = useState(false);
  const [mailSendStatus, setMailSendStatus] = useState(false);
  const [missingValue, setMissingValue] = useState(false);
  const [spritualDirector, setSpritualDirector] = useState(null);
  const [priestStatus, setPriestStatus] = useState(false);
  const [priestLoading, setPriestLoading] = useState(false);
  const [copyMailOpen, setCopyMailOpen] = useState(false);
  const [copyMailTitle, setCopyMailTitle] = useState("");
  const [copyMailList, setCopyMailList] = useState([]);
  const [missingDataLength, setMissingDataLength] = useState("");
  const [missingRosterFieldsLength, setMissingRosterFieldsLength] =
    useState("");
  const [activeFilter, setActiveFilter] = useState(null);
  const activeFilterRef = useRef(null);
  const retreatParishIdRef = useRef(null);
  const [resetKey, setResetKey] = useState(0);
  const [fileSendLoader, setFileSendLoader] = useState(false);
  const [talkAssignOpen, setTalkAssignOpen] = useState(false);
  // Retreat-admin management (used by "Add Retreat Admin" button)
  const [createRetAdmin, setCreateRetAdmin] = useState(false);
  const [adminEdiUserIdClicked, setAdminEdiUserIdClicked] = useState("");
  const [allCoupleMails, setAllCoupleMails] = useState([]);
  const [allCoupleData, setAllCoupleData] = useState([]);
  const [removeAccessModal, setRemoveAccessModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [retreatAdminData, setRetreatAdminData] = useState({ userEmails: [] });
  const [showStatus, setShowStatus] = useState(false);
  const [alertData, setAlertData] = useState([]);
  const [otherParishModalOpen, setOtherParishModalOpen] = useState(false);
  const [sendFileType, setSendFileType] = useState("directory");
  const [data, setData] = useState({
    id: "",
    hisFirstName: "",
    hisLastName: "",
    hisEmail: "",
    hisMobile: "",
    herFirstName: "",
    herLastName: "",
    herEmail: "",
    herMobile: "",
    city: "",
    state: "",
    zip: "",
    notes: "",
    imageUrl: "",
    lastCoupleImage: "",
    parishId: "",
    address: "",
    allergies: "",
    anniversary_date: "",
    under_age_35: "NO",
    emergency_name1: "",
    emergency_relationship1: "",
    emergency_phone1: "",
    emergency_name2: "",
    emergency_relationship2: "",
    emergency_phone2: "",
    hear_us: [],
    referral_from_a_friend_or_family_member: "",
  });
  const [roasterdData, setRoasterdData] = useState({
    id: "",
    hisFirstName: "",
    hisLastName: "",
    hisEmail: "",
    hisMobile: "",
    herFirstName: "",
    herLastName: "",
    herEmail: "",
    herMobile: "",
    city: "",
    state: "",
    zip: "",
    notes: "",
    imageUrl: "",
    attendeeType: "",
    roleId: null,
    subRoleId: null,
    serviceId: null,
    talkId: null,
    parishId: "",
    retreatId: retreatId,
    address: "",
    allergies: "",
    anniversary_date: "",
    under_age_35: "NO",
    emergency_name1: "",
    emergency_relationship1: "",
    emergency_phone1: "",
    emergency_name2: "",
    emergency_relationship2: "",
    emergency_phone2: "",
    hear_us: [],
    referral_from_a_friend_or_family_member: "",
  });

  let authApi = new AuthApi();
  let rolesApi = new RolesApi();
  let serviceApi = new ServiceApi();
  let talksApi = new TalksApi();
  const [parishList, setParishList] = useState([]);
  const [rolesDataList, setrolesDataList] = useState([]);
  const [serviceDataList, setServiceDataList] = useState([]);
  const [talksDataList, setTalksDataList] = useState([]);
  const [alreadyPk, setAlreadyPk] = useState();
  const [validated, setValidated] = useState(false);
  const [oldData, setOldData] = useState([]);
  const [oldValues, setOldValues] = useState([]);
  const [committeeRetreatData, setCommitteeRetreatData] = useState([]);
  const [sendFile, setSendFile] = useState(false);

  const handleShow = (item) => {
    setRoast_id(item);
    setShow(true);
    let d = { ...roasterdData };
    d.id = item.id;
    d.primaryKey = item.primaryKey;
    d.hisFirstName = item.hisFirstName;
    d.hisLastName = item.hisLastName;
    d.hisEmail = item.hisEmail;
    d.herFirstName = item.herFirstName;
    d.herLastName = item.herLastName;
    d.herEmail = item.herEmail;
    setRoasterdData(d);
  };

  const handleAgeChanges = (e, check) => {
    const { name, checked } = e.target;
    if (check === "forRoaster") {
      let o = { ...roasterdData };
      o.under_age_35 = checked ? "YES" : "NO";
      setRoasterdData(o);
    } else {
      let o = { ...data };
      o.under_age_35 = checked ? "YES" : "NO";
      setData(o);
    }
  };

  const handleDatePicker = (e, check) => {
    if (check === "forRoaster") {
      let o = { ...roasterdData };
      o.anniversary_date = e;
      setRoasterdData(o);
    } else {
      let o = { ...data };
      o.anniversary_date = e;
      setData(o);
    }
  };

  const handleCheckboxChange = (e, check) => {
    const { name, checked } = e.target;
    if (check === "forRoaster") {
      let hearUsArray = [];
      if (roasterdData.hear_us && roasterdData.hear_us !== "null") {
        if (Array.isArray(roasterdData.hear_us)) {
          hearUsArray = roasterdData.hear_us;
        } else {
          hearUsArray = JSON.parse(roasterdData.hear_us);
        }
      }
      let updatedOptions;
      if (checked) {
        updatedOptions = [...hearUsArray, name];
      } else {
        updatedOptions = hearUsArray.filter((option) => option !== name);
      }
      setRoasterdData({
        ...roasterdData,
        hear_us: cleanHearUsFinal(updatedOptions),
      });
    } else {
      let hearUsArray =
        data.hear_us !== "null"
          ? Array.isArray(data.hear_us)
            ? data.hear_us
            : JSON.parse(data.hear_us)
          : [];

      let updatedOptions;
      if (checked) {
        updatedOptions = hearUsArray ? [...hearUsArray, name] : [name];
      } else {
        updatedOptions = hearUsArray.filter((option) => option !== name);
      }
      setData({ ...data, hear_us: cleanHearUsFinal(updatedOptions) });
    }
  };

  const cleanHearUsFinal = (val) => {
    const allowed = [
      "Website",
      "Church Bulletin",
      "Facebook",
      "School Marquee",
      "Pulpit Talk/Table in Church",
    ];

    try {
      while (typeof val === "string") {
        val = JSON.parse(val);
      }

      if (!Array.isArray(val)) return [];

      return val.filter(
        (item) => typeof item === "string" && allowed.includes(item),
      );
    } catch {
      return [];
    }
  };

  const getPerishList = async () => {
    await authApi
      .getPerishList()
      .then((response) => {
        const sortedList = response.data.sort((a, b) =>
          a.parish.localeCompare(b.parish),
        );
        setParishList(sortedList);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const getrolesList = async () => {
    await rolesApi
      .getAllRoleList()
      .then(async (response) => {
        const sortedList = response.data.sort((a, b) =>
          a.role.localeCompare(b.role),
        );
        setrolesDataList(response.data);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const committeeRetreats = async () => {
    await committeeApi
      .committeeAccessedRetreats({ committeeId: userData.id })
      .then(async (response) => {
        setCommitteeRetreatData(response.data);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const getServiceList = async () => {
    await serviceApi
      .getAllServiceList()
      .then(async (response) => {
        const sortedList = response.data.sort((a, b) =>
          a.service.localeCompare(b.service),
        );
        setServiceDataList(sortedList);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const getTalksList = async () => {
    await talksApi
      .getAllTalkList()
      .then(async (response) => {
        const sortedList = response.data.sort((a, b) =>
          a.talk.localeCompare(b.talk),
        );
        setTalksDataList(sortedList);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const assignedTalkIds = React.useMemo(() => {
    return allRoasters
      .filter((item) => item.talkId != null && item.id !== roasterdData?.id)
      .map((item) => Number(item.talkId));
  }, [allRoasters, roasterdData]);

  const clearfield = () => {
    setData({
      id: "",
      hisFirstName: "",
      hisLastName: "",
      hisEmail: "",
      hisMobile: "",
      herFirstName: "",
      herLastName: "",
      herEmail: "",
      herMobile: "",
      city: "",
      state: "",
      zip: "",
      notes: "",
      imageUrl: "",
      lastCoupleImage: "",
      parishId: null,
      address: "",
      allergies: "",
      anniversary_date: "",
      under_age_35: "NO",
      emergency_name1: "",
      emergency_relationship1: "",
      emergency_phone1: "",
      emergency_name2: "",
      emergency_relationship2: "",
      emergency_phone2: "",
      hear_us: [],
      referral_from_a_friend_or_family_member: "",
      userRole: "COUPLE",
    });

    setOldValues(null);
    setValidated(false);
  };

  const CloseCompose = () => {
    setIsEditAdmin(false);
    setValidated(false);
    setShowREgModal(false);
    setEdiUserIdClicked("");
    clearfield();
  };

  useEffect(() => {
    getRetreatRoastData();
    getRetreatRoastData1();
    getRetreatDetail();
    leadCoupleData1();
    committeeRetreats();
    getAllCouples();
    getServiceList();
    spritualDirectorData();
    getPerishList();
    if (flag == "1") {
      RetreatData();
    } else if (flag == "2") {
      teamData();
    }
  }, [retreatId]);

  useEffect(() => {

  }, [retreatDetail.title]);

  const [isTempUpload, setIsTempUpload] = useState(false);

  const getCouplesInRetreat = async () => {
    await retreatRoastApi
      .getCouplesInRetreat({ retreatId: retreatId, isTemp })
      .then((res) => {
        if (res.success) {
          let retreatCouple = [];
          res.data &&
            res.data.forEach((item) => {
              if (item.primaryKey) {
                retreatCouple.push({
                  label:
                    `(${
                      item && item.primaryKey ? `${item.primaryKey} - ` : ""
                    }` +
                    `${item && item.hisLastName ? `${item.hisLastName}` : ""}` +
                    `${
                      item && item.hisFirstName ? `, ${item.hisFirstName}` : ""
                    }` +
                    `${
                      item && item.herFirstName
                        ? ` and  ${item.herFirstName}`
                        : ""
                    })`,
                  value: item.id,
                });
              }
            });

          setAllCoupleList(retreatCouple);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        console.error("There is an error!", error);
        toast.error(error);
      });
  };

  const checkPKCouple = async () => {
    await authApi
      .checkPKCouple()
      .then((res) => {
        if (res.success) {
          const nextId =
            res.data != null && Number.isFinite(Number(res.data))
              ? Number(res.data) + 1
              : 1001;
          setAlreadyPk(nextId);
          setData((current) =>
            current && typeof current === "object"
              ? { ...current, primaryKey: nextId }
              : current,
          );
          setRoasterdData((current) => {
            if (!current || typeof current !== "object") return current;
            const inProgress =
              current.id ||
              current.coupleId ||
              current.hisFirstName ||
              current.herFirstName ||
              current.hisEmail ||
              current.herEmail;
            if (inProgress && current.primaryKey) return current;
            return { ...current, primaryKey: nextId };
          });
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
        // console.log('error: ', error);
      });
  };

  const getroastersOfCouple = async (id) => {
    await adminApi
      .participatedInRetreats({ couple_Id: id })
      .then(async (response) => {
        setRoastersOfCoupleList(response.data);
        setRoasterCount(response.totalRecords);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const upload = () => {
    document.getElementById("CoupleProfileUpload").click();
    setIsTempUpload(true);
  };

  const remove1 = () => {
    let d = { ...roasterdData };
    let o = { ...oldData };
    d.imageUrl = "";
    o.imageUrl = "";
    setRoasterdData(d);
    setIsTempUpload(false);
    setOldData(o);
  };

  const editCouple = async (id) => {
    // setIsDisabled(true)
    setEdiUserIdClicked(id);
    setIsTempUpload(false);
    let d = { ...data };
    await adminApi
      .getCouplesDetail({ coupleId: id })
      .then(async (res) => {
        if (
          res.data[0].hisEmail === "tkolkebeck@me.com" ||
          res.data[0].herEmail === "tkolkebeck@satx.rr.com" ||
          res.data[0].hisEmail === "jimmieflores@gmail.com" ||
          res.data[0].herEmail === "dulceaflores@gmail.com"
        ) {
          setIsEditAdmin(true);
        }
        if (res.success) {
          d.id = res.data[0].id;
          d.primaryKey = res.data[0].primaryKey;
          d.hisFirstName = res.data[0].hisFirstName;
          d.hisLastName = res.data[0].hisLastName;
          d.hisEmail = res.data[0].hisEmail;
          d.hisMobile = res.data[0].hisMobile;
          d.herFirstName = res.data[0].herFirstName;
          d.herLastName = res.data[0].herLastName;
          d.herEmail = res.data[0].herEmail;
          d.herMobile = res.data[0].herMobile;
          d.city = res.data[0].city;
          d.state = res.data[0].state;
          d.zip = res.data[0].zip;
          d.notes = res.data[0].notes;
          d.parishId = res.data[0].parishId;
          d.imageUrl = res.data[0].imageUrl;
          d.lastCoupleImage = res.data[0].lastCoupleImage;
          d.address = res.data[0].address;
          d.allergies = res.data[0].allergies;
          d.anniversary_date = res.data[0].anniversary_date
            ? new Date(res.data[0].anniversary_date)
            : "";
          d.under_age_35 = res.data[0].under_age_35;
          d.emergency_name1 = res.data[0].emergency_name1;
          d.emergency_relationship1 = res.data[0].emergency_relationship1;
          d.emergency_phone1 = res.data[0].emergency_phone1;
          d.emergency_name2 = res.data[0].emergency_name2;
          d.emergency_relationship2 = res.data[0].emergency_relationship2;
          d.emergency_phone2 = res.data[0].emergency_phone2;
          d.hear_us = res.data[0].hear_us;
          d.referral_from_a_friend_or_family_member =
            res.data[0].referral_from_a_friend_or_family_member;
          setData(d);
          setOldValues(res.data[0]);

        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const getRetreatRoastData = async (
    pageNo = 1,
    size = 20,
    searchKeyword = null,
    sortBy = {},
    arg5 = null,
    arg6 = null,
  ) => {
    let d = {};
    if (pageNo && size) {
      d.pageNo = pageNo;
      d.size = size;
    }
    if (searchKeyword !== null) {
      d.searchKeyword = searchKeyword;
    } else {
      d.searchKeyword = searchKey;
    }
    if (sortBy.sortColumn) {
      d.sortBy = sortBy;
    }
    d.export = false;
    d.retreatId = retreatId;
    d.isTemp = isTemp;
    let finalFilter = "";
    if (arg5 !== null && typeof arg5 === "string") {
      finalFilter = arg5;
    } else if (arg6 !== null && typeof arg6 === "string") {
      finalFilter = arg6;
    } else {
      finalFilter = activeFilterRef.current || activeFilter || "";
    }
    d.filterBy = finalFilter;
    startLoading();
    await retreatRoastApi
      .getRetreatRoastData(d)
      .then((res) => {
        if (res.success) {
          let totalRecords = res.totalRecords ? res.totalRecords : 0;
          setRetreatRoastData(res.data);
          Setservice_count(res.servTalkTeamTotal.serviceTotal);
          Settalk_count(res.servTalkTeamTotal.talksTotal);
          SetTeam_count(res.servTalkTeamTotal.countTeam);
          Setret_count(res.servTalkTeamTotal.countret);
          setRtp_count(res.servTalkTeamTotal.rtpTotal || 0);
          setTotal(totalRecords);
          setTotalRoast(totalRecords);
          applyRetreatConfirmation(res);
          stopLoading();
        } else {
          stopLoading();
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        console.error("There is an error!", error);
        toast.error(error);
      });
  };

  const clearFilter = async () => {
    activeFilterRef.current = "";
    setActiveFilter("");
    setSearchKey("");
    setMissingValue(false);
    setResetKey((prev) => prev + 1);
    // Explicitly pass empty search and filter to override state lag
    getRetreatRoastData(1, 20, "", {}, "", "");
    getRetreatRoastData1(1, 20, "");
  };

  const handleClientSearch = (fullData, keyword) => {
    if (!keyword || keyword.trim() === "") return fullData;
    const key = keyword.toLowerCase();
    return fullData.filter((item) => {
      return (
        (item.hisFirstName && item.hisFirstName.toLowerCase().includes(key)) ||
        (item.hisLastName && item.hisLastName.toLowerCase().includes(key)) ||
        (item.herFirstName && item.herFirstName.toLowerCase().includes(key)) ||
        (item.herLastName && item.herLastName.toLowerCase().includes(key)) ||
        (item.hisEmail && item.hisEmail.toLowerCase().includes(key)) ||
        (item.herEmail && item.herEmail.toLowerCase().includes(key)) ||
        (item.primaryKey && item.primaryKey.toLowerCase().includes(key)) ||
        (item.mainRole && item.mainRole.toLowerCase().includes(key)) ||
        (item.service && item.service.toLowerCase().includes(key)) ||
        (item.talk && item.talk.toLowerCase().includes(key)) ||
        (item.parish && item.parish.toLowerCase().includes(key)) ||
        (item.hisMobile && item.hisMobile.toLowerCase().includes(key)) ||
        (item.herMobile && item.herMobile.toLowerCase().includes(key))
      );
    });
  };

  const applyFilter = async (filterType) => {
    setMissingValue(false);
    activeFilterRef.current = filterType;
    setActiveFilter(filterType);
    getRetreatRoastData(1, 20, searchKey, {}, false, filterType);
  };

  const refreshWithActiveFilter = () => {
    if (activeFilter) {
      applyFilter(activeFilter);
    } else {
      applyFilter("");
      getRetreatRoastData1();
    }
  };

  const spritualDirectorData = async () => {
    let d = {};
    d.retreatId = retreatId;
    d.isTemp = isTemp;
    await retreatRoastApi
      .getSpritualDirectorData(d)
      .then((res) => {
        if (res.success) {
          // setRetreatRoastData(res.data);
          // setAllRoasters(res.data);
          // setTotal(res.totalRecords);
          setSpritualDirector(res.data);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        console.error("There is an error!", error);
        toast.error(error);
      });
  };

  const closePriestAlert = () => {
    setPriestStatus(false);
    setPriestLoading(false);
  };

  const openSpiritualDirector = async () => {
    if (spritualDirector_count === 0) return;
    setPriestStatus(true);
    setPriestLoading(true);
    try {
      await spritualDirectorData();
    } finally {
      setPriestLoading(false);
    }
  };

  const leadCoupleData1 = async () => {
    let d = {};
    d.retreatId = retreatId;
    d.isTemp = isTemp;
    await retreatRoastApi
      .getLeadCoupleRoastData(d)
      .then((res) => {
        if (res.success) {
          setRetreatRoastLeadData(res.data);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        console.error("There is an error!", error);
        toast.error(error);
      });
  };

  const setStates = async (row) => {
    setEdiUserIdClicked(row.id);
    const base =
      roasterdData && typeof roasterdData === "object" ? roasterdData : {};
    let d = { ...base };
    let r = { ...oldData };
    const anniversary = row?.anniversary_date ? new Date(row.anniversary_date) : "";
    d.id = row && row.id;
    d.primaryKey = row && row.primaryKey;
    d.hisLastName = row && row.hisLastName;
    d.hisFirstName = row && row.hisFirstName;
    d.herFirstName = row && row.herFirstName;
    d.hisEmail = row && row.hisEmail;
    d.hisMobile = row && row.hisMobile;
    d.herLastName = row && row.herLastName;
    d.herEmail = row && row.herEmail;
    d.herMobile = row && row.herMobile;
    d.city = row && row.city;
    d.state = row && row.state;
    d.zip = row && row.zip;
    d.notes = row && row.notes;
    d.imageUrl = row && row.imageUrl;
    d.parishId = row && row.parishId;
    d.attendeeType = row && row.attendeeType;
    d.roleId = row && row.roleId;
    d.subRoleId = row && row.subRoleId;
    d.serviceId = row && row.serviceId;
    d.talkId = row && row.talkId;
    d.coupleId = row && row.coupleId;
    d.address = row && row.address;
    d.mainRole = row && row.mainRole;
    d.allergies = row && row.allergies;
    d.anniversary_date =
      anniversary instanceof Date && !Number.isNaN(anniversary.getTime())
        ? anniversary
        : "";
    d.under_age_35 = row && row.under_age_35;
    d.emergency_name1 = row && row.emergency_name1;
    d.emergency_relationship1 = row && row.emergency_relationship1;
    d.emergency_phone1 = row && row.emergency_phone1;
    d.emergency_name2 = row && row.emergency_name2;
    d.emergency_relationship2 = row && row.emergency_relationship2;
    d.emergency_phone2 = row && row.emergency_phone2;
    d.hear_us = row && row.hear_us;
    d.referral_from_a_friend_or_family_member =
      row && row.referral_from_a_friend_or_family_member;

    setRoasterdData(d);
    setOldValues(row);
    getPerishList();
    getrolesList();
    getServiceList();
    getTalksList();
  };

  const handleChangeRoaster = (e) => {
    let { name, value } = e.target;
    let d = { ...roasterdData };
    let o = { ...oldData };
    if (name === "hisFirstName") {
      o.hisFirstName = oldValues && oldValues.hisFirstName;
    } else if (name === "hisLastName") {
      o.hisLastName = oldValues && oldValues.hisLastName;
    } else if (name === "hisEmail") {
      o.hisEmail = oldValues && oldValues.hisEmail;
    } else if (name === "hisMobile") {
      o.hisMobile = oldValues && oldValues.hisMobile;
    } else if (name === "herFirstName") {
      o.herFirstName = oldValues && oldValues.herFirstName;
    } else if (name === "herLastName") {
      o.herLastName = oldValues && oldValues.herLastName;
    } else if (name === "herEmail") {
      o.herEmail = oldValues && oldValues.herEmail;
    } else if (name === "herMobile") {
      o.herMobile = oldValues && oldValues.herMobile;
    } else if (name === "parishId") {
      if (value === "OTHER") {
        setOtherParishModalOpen(true);
      }
      if (value === "") {
        value = retreatDetail.parishId;
      }

      o.parishId = oldValues && oldValues.parishId;
    } else if (name === "notes") {
      o.notes = oldValues && oldValues.notes;
    } else if (name === "zip") {
      o.zip = oldValues && oldValues.zip;
    } else if (name === "city") {
      o.city = oldValues && oldValues.city;
    } else if (name === "state") {
      o.state = oldValues && oldValues.state;
    } else if (name === "imageUrl") {
      o.imageUrl = oldValues && oldValues.imageUrl;
    } else if (name === "attendeeType") {
      o.attendeeType = oldValues && oldValues.attendeeType;
    } else if (name === "roleId") {
      o.roleId = oldValues && oldValues.roleId;
    } else if (name === "subRoleId") {
      o.subRoleId = oldValues && oldValues.subRoleId;
    } else if (name === "serviceId") {
      o.serviceId = oldValues && oldValues.serviceId;
    } else if (name === "talkId") {
      o.talkId = oldValues && oldValues.talkId;
    } else if (name === "retreatId") {
      o.retreatId = oldValues && oldValues.retreatId;
    }
    setOldData(o);
    if (name == "imageUrl") {
      d.imageUrl = e.target.files[0];
      toast.success("The profile image has been successfully added.");
    } else {
      d[name] = value;
    }
    setRoasterdData(d);

    if (name === "hisEmail" || name === "herEmail") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value && !emailRegex.test(value)) {
        setEmailErrors((prev) => ({ ...prev, [name]: "Invalid email format" }));
      } else {
        setEmailErrors((prev) => ({ ...prev, [name]: "" }));
      }
    }
  };

  const handleRoasterData = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    const hasErrors = Object.values(emailErrors).some((error) => error !== "");
    if (hasErrors) {
      toast.error("Please enter valid email addresses.");
      return;
    }

    if (
      isNewCouple &&
      coupleEntryMode === "existing" &&
      !(roasterdData && roasterdData.coupleId)
    ) {
      toast.error("Select an existing couple before adding them to this retreat.");
      return;
    }

    if (form.checkValidity()) {
      const hasEmergencyContact1 =
        roasterdData.emergency_name1 &&
        roasterdData.emergency_phone1 &&
        roasterdData.emergency_relationship1;

      const hasEmergencyContact2 =
        roasterdData.emergency_name2 &&
        roasterdData.emergency_phone2 &&
        roasterdData.emergency_relationship2;

      if (!hasEmergencyContact1 && !hasEmergencyContact2) {
        toast.error(
          "Please provide at least one emergency contact with full details.",
        );
        return;
      }
      if (
        ediUserIdClicked &&
        ediUserIdClicked !== "" &&
        ediUserIdClicked !== null
      ) {
        let data1 = new FormData();
        if (roasterdData.imageUrl instanceof File) {
          data1.append("file", roasterdData.imageUrl);
        }
        let stateRef = { ...roasterdData };
        if (stateRef.parishId === "" || stateRef.parishId === null) {
          stateRef.parishId = retreatDetail.parishId;
        }
        // delete stateRef.imageUrl
        data1.append("fromData", JSON.stringify(stateRef));
        data1.append("isTemp", isTemp);
        retreatRoastApi
          .updateRoaster(data1)
          .then(async (res) => {
            if (res.success) {
              if (res && res.data && res.data[0]) {
                userData.imageUpload =
                  res && res.data && res.data[0] && res.data[0].imageUrl
                    ? res.data[0].imageUrl
                    : "";
                if (userData.coupleId === res.data[0].id) {
                  setCookie("LoveStrongUser", userData, {
                    path: "/",
                    maxAge: 60 * 60 * 100,
                    expires: new Date(Date.now() + 60 * 60 * 100),
                  });
                }
                toast.success(res.msg);




















                let oldRole = rolesDataList.find(
                  (i) => i.id === oldData.roleId,
                );
                let newRole = rolesDataList.find(
                  (i) => i.id === res.roastData.roleId,
                );


                let oldService = serviceDataList.find(
                  (i) => i.id === oldData.serviceId,
                );
                let newService = serviceDataList.find(
                  (i) => i.id === res.roastData.serviceId,
                );


                let oldTalk = talksDataList.find(
                  (i) => i.talkId == oldData.talkId,
                );
                let newTalk = talksDataList.find(
                  (i) => i.talkId == res.roastData.talkId,
                );


                let oldparish = parishList.find(
                  (i) => i.id === oldData.parishId,
                );
                let newparish = parishList.find(
                  (i) => i.id === res.data[0].parishId,
                );

                setOldData(null);
                clearfield();
                setRoasterdData({
                  id: "",
                  hisFirstName: "",
                  hisLastName: "",
                  hisEmail: "",
                  hisMobile: "",
                  herFirstName: "",
                  herLastName: "",
                  herEmail: "",
                  herMobile: "",
                  city: "",
                  state: "",
                  zip: "",
                  notes: "",
                  imageUrl: "",
                  attendeeType: "",
                  roleId: null,
                  subRoleId: null,
                  serviceId: null,
                  talkId: null,
                  retreatId: retreatId,
                  parishId: "",
                });
                setShowModel(false);
                setShowModel(false);
                setResetKey((prev) => prev + 1);
                refreshWithActiveFilter();
                getRetreatRoastData1();
                spritualDirectorData();
                leadCoupleData1();
                setIsTempUpload(false);
                // setIsTempUpload2(false);
                setIsNewCouple(false);
                getCouplesInRetreat();
              }
            } else {
              toast.error(res.msg);
            }
          })
          .catch((error) => {
            toast.error(error);
          });
      } else {
        let data1 = new FormData();
        if (roasterdData.imageUrl instanceof File) {
          data1.append("file", roasterdData.imageUrl);
        }
        let stateRef = { ...roasterdData };
        if (stateRef.parishId === "" || stateRef.parishId === null) {
          stateRef.parishId = retreatDetail.parishId;
        }
        delete stateRef.imageUrl;
        data1.append("fromData", JSON.stringify(stateRef));
        data1.append("isTemp", isTemp);
        retreatRoastApi
          .CreateRoaster(data1)
          .then(async (res) => {
            if (res.success) {

              toast.success(res.msg);
              clearfield();
              remove1();
              // removeMarriagePhoto1();
              setShowModel(false);
              setShowModel(false);
              setResetKey((prev) => prev + 1);
              refreshWithActiveFilter();
              getRetreatRoastData1();
              spritualDirectorData();
              leadCoupleData1();
              getCouplesInRetreat();
              setRoasterdData({
                id: "",
                hisFirstName: "",
                hisLastName: "",
                hisEmail: "",
                hisMobile: "",
                herFirstName: "",
                herLastName: "",
                herEmail: "",
                herMobile: "",
                city: "",
                state: "",
                zip: "",
                notes: "",
                imageUrl: "",
                attendeeType: "",
                roleId: null,
                subRoleId: null,
                serviceId: null,
                talkId: null,
                retreatId: retreatId,
                parishId: "",
              });
            } else {
              toast.error(res.msg);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
    setValidated(true);
  };

  const blankRoasterRecord = (primaryKey = "") => ({
    id: "",
    hisFirstName: "",
    hisLastName: "",
    hisEmail: "",
    hisMobile: "",
    herFirstName: "",
    herLastName: "",
    herEmail: "",
    herMobile: "",
    city: "",
    state: "",
    zip: "",
    notes: "",
    imageUrl: "",
    attendeeType: "",
    roleId: null,
    subRoleId: null,
    serviceId: null,
    talkId: null,
    parishId: "",
    retreatId,
    address: "",
    allergies: "",
    anniversary_date: "",
    under_age_35: "NO",
    emergency_name1: "",
    emergency_relationship1: "",
    emergency_phone1: "",
    emergency_name2: "",
    emergency_relationship2: "",
    emergency_phone2: "",
    hear_us: [],
    referral_from_a_friend_or_family_member: "",
    primaryKey,
    coupleId: "",
  });

  const addRoaster = async () => {
    setIsNewCouple(true);
    setCoupleEntryMode("new");
    setExistingCoupleOption(null);
    setValidated(false);
    setIsEditAdmin(false);
    setIsTempUpload(false);
    setEmailErrors({});
    setRoasterdData(blankRoasterRecord(alreadyPk || ""));
    setShowModel(true);
    getPerishList();
    getrolesList();
    getServiceList();
    getTalksList();
    getAllCouples();
    try {
      const res = await authApi.checkPKCouple();
      if (res?.success) {
        const nextId =
          res.data != null && Number.isFinite(Number(res.data))
            ? Number(res.data) + 1
            : 1001;
        setAlreadyPk(nextId);
        setData((current) =>
          current && typeof current === "object"
            ? { ...current, primaryKey: nextId }
            : current,
        );
        setRoasterdData((current) => {
          if (!current || typeof current !== "object") {
            return blankRoasterRecord(nextId);
          }
          if (current.coupleId) return current;
          return { ...current, primaryKey: nextId };
        });
      } else if (res?.msg) {
        toast.error(res.msg);
      }
    } catch (error) {
      toast.error(
        typeof error === "string" ? error : "Could not assign a couple id.",
      );
    }
  };

  const closeCoupleModal = () => {
    setShowModel(false);
    setEdiUserIdClicked("");
    setRoasterdData("");
    setCoupleEntryMode("new");
    setExistingCoupleOption(null);
    setValidated(false);
    setIsTempUpload(false);
    setIsEditAdmin(false);
  };

  const chooseCoupleEntryMode = (mode) => {
    if (mode === coupleEntryMode) return;
    setCoupleEntryMode(mode);
    setValidated(false);
    setEmailErrors({});
    setIsEditAdmin(false);
    setIsTempUpload(false);
    setExistingCoupleOption(null);
    setRoasterdData(blankRoasterRecord(alreadyPk || ""));
  };

  const handleSelectCuple = async (val) => {
    setExistingCoupleOption(val || null);
    if (!val || !val.value) {
      setIsEditAdmin(false);
      setIsTempUpload(false);
      setRoasterdData(blankRoasterRecord(alreadyPk || ""));
      return;
    }
    if (val.value) {
      let d = { ...roasterdData };
      await adminApi
        .getCouplesDetail({ coupleId: val.value })
        .then(async (res) => {
          if (
            res.data[0].hisEmail === "tkolkebeck@me.com" ||
            res.data[0].herEmail === "tkolkebeck@satx.rr.com" ||
            res.data[0].hisEmail === "jimmieflores@gmail.com" ||
            res.data[0].herEmail === "dulceaflores@gmail.com"
          ) {
            setIsEditAdmin(true);
          }
          if (res.success) {
            // setEdiUserIdClicked(res.data[0].id);
            d.primaryKey = res.data[0].primaryKey;
            d.hisFirstName = res.data[0].hisFirstName;
            d.hisLastName = res.data[0].hisLastName;
            d.hisEmail = res.data[0].hisEmail;
            d.hisMobile = res.data[0].hisMobile;
            d.herFirstName = res.data[0].herFirstName;
            d.herLastName = res.data[0].herLastName;
            d.herEmail = res.data[0].herEmail;
            d.herMobile = res.data[0].herMobile;
            d.city = res.data[0].city;
            d.state = res.data[0].state;
            d.zip = res.data[0].zip;
            d.notes = res.data[0].notes;
            d.imageUrl = res.data[0].imageUrl;
            d.lastCoupleImage = res.data[0].lastCoupleImage;
            d.parishId = res.data[0].parishId;
            d.coupleId = res.data[0].id;
            d.address = res.data[0].address;
            d.allergies = res.data[0].allergies;
            d.anniversary_date = res.data[0].anniversary_date
              ? new Date(res.data[0].anniversary_date)
              : "";
            d.under_age_35 = res.data[0].under_age_35;
            d.emergency_name1 = res.data[0].emergency_name1;
            d.emergency_relationship1 = res.data[0].emergency_relationship1;
            d.emergency_phone1 = res.data[0].emergency_phone1;
            d.emergency_name2 = res.data[0].emergency_name2;
            d.emergency_relationship2 = res.data[0].emergency_relationship2;
            d.emergency_phone2 = res.data[0].emergency_phone2;
            d.hear_us = res.data[0].hear_us;
            d.referral_from_a_friend_or_family_member =
              res.data[0].referral_from_a_friend_or_family_member;
            setRoasterdData(d);
          } else {
            toast.error(res.msg);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };

  const renderEditRetreatModel = () => {
    const waitingForExistingCouple =
      isNewCouple &&
      coupleEntryMode === "existing" &&
      !(roasterdData && roasterdData.coupleId);
    const hasCouplePhoto =
      roasterdData?.imageUrl !== "" && roasterdData?.imageUrl != undefined;

    const renderRoasterForm = () => (
      <Form
        onSubmit={handleRoasterData}
        noValidate
        validated={validated}
        className="forms-sample rr-couple-form"
      >
        <Modal.Body className="rr-couple-body">
          {isNewCouple ? (
            <div className="rr-couple-mode">
              <span className="rr-couple-mode-label">Add this couple</span>
              <div
                className="rr-couple-mode-switch"
                role="tablist"
                aria-label="How to add this couple"
              >
                <button
                  type="button"
                  role="tab"
                  aria-selected={coupleEntryMode === "new"}
                  className={coupleEntryMode === "new" ? "is-active" : ""}
                  onClick={() => chooseCoupleEntryMode("new")}
                >
                  Add new couple
                </button>
                <button
                  type="button"
                  role="tab"
                  aria-selected={coupleEntryMode === "existing"}
                  className={coupleEntryMode === "existing" ? "is-active" : ""}
                  onClick={() => chooseCoupleEntryMode("existing")}
                >
                  Select Couple from existing Couple Data
                </button>
              </div>
            </div>
          ) : null}

          {isNewCouple && coupleEntryMode === "existing" ? (
            <section className="rr-couple-card rr-couple-card--search">
              <div className="rr-couple-section-head">
                <span className="rr-couple-section-icon" aria-hidden="true">
                  <Search size={16} />
                </span>
                <div>
                  <h3>Find a couple</h3>
                  <p>
                    Search the directory, then review their details before
                    adding them to this retreat.
                  </p>
                </div>
              </div>
              <Select
                name="Couples"
                className="rr-couple-select"
                classNamePrefix="rr-couple-select"
                options={allCoupleData}
                value={existingCoupleOption}
                onChange={handleSelectCuple}
                placeholder="Search by name or couple id"
                isSearchable
                isClearable
                isMulti={false}
                menuPortalTarget={
                  typeof document !== "undefined" ? document.body : null
                }
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 2000 }),
                }}
                noOptionsMessage={() => "No couples match that search"}
              />
            </section>
          ) : null}

          {waitingForExistingCouple ? (
            <div className="rr-couple-empty">
              <Users size={22} />
              <div>
                <strong>Choose a couple to continue</strong>
                <p>
                  Search by name or couple id. Their details will appear here
                  so you can review them before adding them to this retreat.
                </p>
              </div>
            </div>
          ) : (
          <div className="rr-couple-fields">
          <section className="rr-couple-section rr-couple-identity">
            <div className="rr-couple-photo-wrap">
              <div
                className={`rr-couple-photo${
                  hasCouplePhoto ? "" : " is-empty"
                }`}
              >
                {hasCouplePhoto ? (
                  <img
                    src={
                      isTempUpload
                        ? URL.createObjectURL(roasterdData.imageUrl)
                        : roasterdData.imageUrl
                    }
                    alt="Couple"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = corruptedImg;
                    }}
                  />
                ) : (
                  <img src={Profile} alt="" />
                )}
              </div>
              {hasCouplePhoto ? (
                <button
                  type="button"
                  className="rr-couple-photo-btn is-danger"
                  onClick={() => remove1()}
                >
                  Remove photo
                </button>
              ) : (
                <>
                  <input
                    name="imageUrl"
                    type="file"
                    accept="image/*"
                    id="CoupleProfileUpload"
                    onChange={(e) => handleChangeRoaster(e)}
                  />
                  <button
                    type="button"
                    className="rr-couple-photo-btn"
                    onClick={() => upload()}
                  >
                    Upload photo
                  </button>
                </>
              )}
            </div>
            <div className="rr-couple-identity-main">
              <Form.Group className="rr-couple-id">
                <Form.Label htmlFor="primaryKey">Couple ID</Form.Label>
                <Form.Control
                  required
                  size="sm"
                  type="text"
                  name="primaryKey"
                  id="primaryKey"
                  placeholder="Assigningâ€¦"
                  value={roasterdData.primaryKey ?? ""}
                  className="form-control"
                  onChange={(e) => handleChangeRoaster(e)}
                  readOnly
                />
                <span className="rr-couple-hint">
                  Assigned automatically. This id is used on the roster.
                </span>
                <Form.Control.Feedback type="invalid">
                  Couple Id is required!
                </Form.Control.Feedback>
              </Form.Group>
              <label className="rr-couple-age" htmlFor="under_age_35">
                <input
                  id="under_age_35"
                  type="checkbox"
                  name="under_age_35"
                  checked={roasterdData.under_age_35 === "YES"}
                  onChange={(e) => {
                    handleAgeChanges(e, "forRoaster");
                  }}
                />
                <span>
                  <strong>35 or younger</strong>
                  <small>
                    Check this if either spouse is 35 years of age or younger.
                  </small>
                </span>
              </label>
            </div>
          </section>

          <section className="rr-couple-section">
            <div className="rr-couple-section-head">
              <span className="rr-couple-section-icon" aria-hidden="true">
                <Heart size={16} />
              </span>
              <div>
                <h3>Couple</h3>
                <p>Names, email, and phone for each spouse.</p>
              </div>
            </div>
            <Row className="rr-couple-people">
            <Col lg={6} md={6} xs={12}>
              <div className="rr-couple-person rr-couple-person--his">
                <div className="rr-couple-person-title">His information</div>
              <div id="his-info">
                <Col lg={12} md={12} xs={12}>
                  <Form.Group className="form-group">
                    <Form.Label
                      className={
                        roasterdData.hisFirstName ? null : "highlightField mt-2"
                      }
                    >
                      First Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      // required
                      size="sm"
                      type="text"
                      name="hisFirstName"
                      id="hisFirstName"
                      placeholder="First Name"
                      value={roasterdData.hisFirstName}
                      className="form-control"
                      onChange={(e) => handleChangeRoaster(e)}
                      readOnly={isEditAdmin}
                    />
                    <Form.Control.Feedback type="invalid">
                      FirstName is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={12} md={12} xs={12}>
                  <Form.Group className="form-group">
                    <Form.Label
                      className={
                        roasterdData.hisLastName ? null : "highlightField"
                      }
                    >
                      Last Name
                    </Form.Label>
                    <Form.Control
                      // required
                      size="sm"
                      type="text"
                      name="hisLastName"
                      id="hisLastName"
                      placeholder="Last Name"
                      value={roasterdData.hisLastName}
                      className="form-control"
                      onChange={(e) => handleChangeRoaster(e)}
                      readOnly={isEditAdmin}
                    />
                    <Form.Control.Feedback type="invalid">
                      LastName is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={12} md={12} xs={12}>
                  <Form.Group className="form-group col">
                    <Form.Label
                      className={
                        roasterdData.hisEmail ? null : "highlightField"
                      }
                    >
                      Email <span className="text-danger">*</span>
                    </Form.Label>
                    <CopyableInput
                      // required
                      size="sm"
                      type="text"
                      name="hisEmail"
                      id="hisEmail"
                      placeholder="Email"
                      value={roasterdData.hisEmail}
                      onChange={(e) => handleChangeRoaster(e)}
                      readOnly={isEditAdmin}
                    />
                    {emailErrors.hisEmail && (
                      <span
                        className="text-danger"
                        style={{ fontSize: "12px" }}
                      >
                        {emailErrors.hisEmail}
                      </span>
                    )}
                    <Form.Control.Feedback type="invalid">
                      Email is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={12} md={12} xs={12}>
                  <Form.Group className="form-group col">
                    <Form.Label
                      className={
                        roasterdData.hisMobile ? null : "highlightField"
                      }
                    >
                      Mobile
                    </Form.Label>
                    <PhoneInput
                      name="hisMobile"
                      value={roasterdData.hisMobile}
                      onChange={(e) => handleChangeRoaster(e)}
                    />
                  </Form.Group>
                </Col>
              </div>
              </div>
            </Col>
            <Col lg={6} md={6} xs={12}>
              <div className="rr-couple-person rr-couple-person--her">
                <div className="rr-couple-person-title">Her information</div>
              <div id="her-info">
                <Col lg={12} md={12} xs={12}>
                  <Form.Group className="form-group">
                    <Form.Label
                      className={
                        roasterdData.herFirstName ? null : "highlightField mt-2"
                      }
                    >
                      First Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      // required
                      size="sm"
                      type="text"
                      name="herFirstName"
                      id="herFirstName"
                      placeholder="First Name"
                      value={roasterdData.herFirstName}
                      onChange={(e) => handleChangeRoaster(e)}
                      readOnly={isEditAdmin}
                    />
                    <Form.Control.Feedback type="invalid">
                      FirstName is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={12} md={12} xs={12}>
                  <Form.Group className="form-group">
                    <Form.Label
                      className={
                        roasterdData.herLastName ? null : "highlightField"
                      }
                    >
                      Last Name
                    </Form.Label>
                    <Form.Control
                      // required
                      size="sm"
                      type="text"
                      name="herLastName"
                      id="herLastName"
                      placeholder="Last Name"
                      value={roasterdData.herLastName}
                      onChange={(e) => handleChangeRoaster(e)}
                      readOnly={isEditAdmin}
                    />
                    <Form.Control.Feedback type="invalid">
                      LastName is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={12} md={12} xs={12}>
                  <Form.Group className="form-group">
                    <Form.Label
                      className={
                        roasterdData.herEmail ? null : "highlightField"
                      }
                    >
                      Email <span className="text-danger">*</span>
                    </Form.Label>
                    <CopyableInput
                      size="sm"
                      type="text"
                      name="herEmail"
                      id="herEmail"
                      placeholder="Email"
                      value={roasterdData.herEmail}
                      onChange={(e) => handleChangeRoaster(e)}
                      readOnly={isEditAdmin}
                    />
                    {emailErrors.herEmail && (
                      <span
                        className="text-danger"
                        style={{ fontSize: "12px" }}
                      >
                        {emailErrors.herEmail}
                      </span>
                    )}
                    <Form.Control.Feedback type="invalid">
                      Email is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={12} md={12} xs={12}>
                  <Form.Group className="form-group">
                    <Form.Label
                      className={
                        roasterdData.herMobile ? null : "highlightField"
                      }
                    >
                      Mobile
                    </Form.Label>
                    <PhoneInput
                      name="herMobile"
                      value={roasterdData.herMobile}
                      onChange={(e) => handleChangeRoaster(e)}
                    />
                  </Form.Group>
                </Col>
              </div>
              </div>
            </Col>
          </Row>
          </section>

          <section className="rr-couple-section">
            <div className="rr-couple-section-head">
              <span className="rr-couple-section-icon" aria-hidden="true">
                <MapPin size={16} />
              </span>
              <div>
                <h3>Home</h3>
                <p>
                  Address, parish, anniversary, and anything the team should
                  know.
                </p>
              </div>
            </div>
            <div className="row">
            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form.Label
                className={roasterdData.address ? null : "highlightField"}
              >
                Address
              </Form.Label>
              <Form.Control
                // required
                size="sm"
                type="text"
                name="address"
                id="address"
                placeholder="Address"
                value={roasterdData.address}
                onChange={(e) => handleChangeRoaster(e)}
              />
              <Form.Control.Feedback type="invalid">
                Address is required!
              </Form.Control.Feedback>
            </Form.Group>

            {/* <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <Form.Label
                  className={roasterdData.address ? null : "highlightField"}
                >
                  Address
                </Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  name="address"
                  id="address"
                  placeholder="Search address"
                  value={roasterdData.address}
                  onChange={handleSearch}
                  autoComplete="off"
                />
                <Form.Control.Feedback type="invalid">
                  Address is required!
                </Form.Control.Feedback>
                {suggestions.length > 0 && (
                  <ul
                    className="list-group position-absolute w-100 mt-1"
                    style={{
                      zIndex: 1000,
                      maxHeight: "200px",
                      overflowY: "auto",
                    }}
                  >
                    {suggestions.map((address) => (
                      <li
                        key={address.place_id}
                        onClick={() => handleSelect(address)}
                        className="list-group-item list-group-item-action"
                        style={{ cursor: "pointer" }}
                      >
                        {address.display_name}
                      </li>
                    ))}
                  </ul>
                )}
              </Form.Group> */}

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form.Label
                className={roasterdData.state ? null : "highlightField"}
              >
                State
              </Form.Label>
              <Form.Select
                className="form-control minimal"
                size="sm"
                type="text"
                name="state"
                id="state"
                placeholder="State"
                value={roasterdData.state}
                onChange={(e) => handleChangeRoaster(e)}
              >
                <option value="">Select State</option>
                <option value="Alaska">Alaska</option>
                <option value="Alabama">Alabama</option>
                <option value="Arkansas">Arkansas</option>
                <option value="Arizona">Arizona</option>
                <option value="California">California</option>
                <option value="Colorado">Colorado</option>
                <option value="Connecticut">Connecticut</option>
                <option value="District of Columbia">
                  District of Columbia
                </option>
                <option value="Delaware">Delaware</option>
                <option value="Florida">Florida</option>
                <option value="Georgia">Georgia</option>
                <option value="Hawaii">Hawaii</option>
                <option value="Iowa">Iowa</option>
                <option value="Idaho">Idaho</option>
                <option value="Illinois">Illinois</option>
                <option value="Indiana">Indiana</option>
                <option value="Kansas">Kansas</option>
                <option value="Kentucky">Kentucky</option>
                <option value="Louisiana">Louisiana</option>
                <option value="Massachusetts">Massachusetts</option>
                <option value="Maryland">Maryland</option>
                <option value="Maine">Maine</option>
                <option value="Michigan">Michigan</option>
                <option value="Minnesota">Minnesota</option>
                <option value="Missouri">Missouri</option>
                <option value="Mississippi">Mississippi</option>
                <option value="Montana">Montana</option>
                <option value="North Carolina">North Carolina</option>
                <option value="North Dakota">North Dakota</option>
                <option value="Nebraska">Nebraska</option>
                <option value="New Hampshire">New Hampshire</option>
                <option value="New Jersey">New Jersey</option>
                <option value="New Mexico">New Mexico</option>
                <option value="Nevada">Nevada</option>
                <option value="New York">New York</option>
                <option value="Ohio">Ohio</option>
                <option value="Oklahoma">Oklahoma</option>
                <option value="Oregon">Oregon</option>
                <option value="Pennsylvania">Pennsylvania</option>
                <option value="Puerto Rico">Puerto Rico</option>
                <option value="Rhode Island">Rhode Island</option>
                <option value="South Carolina">South Carolina</option>
                <option value="South Dakota">South Dakota</option>
                <option value="Tennessee">Tennessee</option>
                <option value="Texas">Texas</option>
                <option value="Utah">Utah</option>
                <option value="Virginia">Virginia</option>
                <option value="Vermont">Vermont</option>
                <option value="Washington">Washington</option>
                <option value="Wisconsin">Wisconsin</option>
                <option value="West Virginia">West Virginia</option>
                <option value="Wyoming">Wyoming</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                State is required!
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form.Label
                className={roasterdData.city ? null : "highlightField"}
              >
                City
              </Form.Label>
              <Form.Control
                // required
                size="sm"
                type="text"
                name="city"
                id="city"
                placeholder="City"
                value={roasterdData.city}
                onChange={(e) => handleChangeRoaster(e)}
              />
              <Form.Control.Feedback type="invalid">
                City is required!
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form.Label
                className={roasterdData.zip ? null : "highlightField"}
              >
                Zip
              </Form.Label>
              <Form.Control
                // required
                size="sm"
                type="text"
                name="zip"
                id="zip"
                placeholder="Zip"
                value={roasterdData.zip}
                onChange={(e) => handleChangeRoaster(e)}
              />
              <Form.Control.Feedback type="invalid">
                Zip is required!
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form.Label
                className={`label-inline ${
                  roasterdData.parishId || retreatDetail.parishId
                    ? ""
                    : "highlightField"
                }`}
              >
                Parish <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                required
                className="form-control minimal"
                size="sm"
                type="text"
                name="parishId"
                id="parishId"
                placeholder="Parish"
                value={roasterdData.parishId || retreatDetail.parishId}
                onChange={(e) => handleChangeRoaster(e)}
              >
                <option value="">NONE / NINGUNA</option>
                <option value="OTHER">OTHER / OTRA</option>
                <optgroup label="Select Parish">
                  {parishList
                    .filter(
                      (p) => p.parishCategoryName?.toUpperCase() !== "OTHER",
                    )
                    .map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {formatParishOptionLabel(item)}
                        </option>
                      );
                    })}
                </optgroup>
                <optgroup label="OTHER">
                  {parishList
                    .filter(
                      (p) => p.parishCategoryName?.toUpperCase() === "OTHER",
                    )
                    .map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {formatParishOptionLabel(item, {
                            omitCategory: true,
                          })}
                        </option>
                      );
                    })}
                </optgroup>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Parish is required!
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form.Label
                className={`label-inline ${
                  !roasterdData.anniversary_date &&
                  roasterdData.mainRole !== "Spiritual Mentor"
                    ? "highlightField"
                    : ""
                }`}
              >
                Anniversary Date (Month/Year){" "}
                {roasterdData.mainRole === "Spiritual Mentor" ? null : (
                  <span className="text-danger">*</span>
                )}
              </Form.Label>

              <DatePicker
                required={
                  roasterdData.mainRole === "Spiritual Mentor" ? false : true
                }
                autoComplete="off"
                dateFormat="MM-dd-yyyy"
                placeholderText="mm-dd-yyyy"
                selected={roasterdData && roasterdData.anniversary_date}
                onChange={(e) => handleDatePicker(e, "forRoaster")}
                className="form-select setdate datepicker"
                name="anniversary_date"
                id="anniversary_date"
                maxDate={new Date()}
                showDisabledMonthNavigation
                renderCustomHeader={({
                  date,
                  changeYear,
                  changeMonth,
                  decreaseMonth,
                  increaseMonth,
                  prevMonthButtonDisabled,
                  nextMonthButtonDisabled,
                }) => {
                  const years = Array.from(
                    { length: 100 },
                    (_, i) => new Date().getFullYear() - i,
                  );
                  const months = [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                  ];

                  return (
                    <div
                      style={{
                        textAlign: "center",
                        paddingBottom: "8px",
                      }}
                    >
                      {/* âœ… BIGGER Month + Year dropdowns ABOVE */}
                      <div
                        style={{
                          marginBottom: "10px",
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        {/* Month Dropdown */}
                        <select
                          style={{
                            fontSize: "16px",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                          }}
                          value={months[date.getMonth()]}
                          onChange={({ target: { value } }) =>
                            changeMonth(months.indexOf(value))
                          }
                        >
                          {months.map((month) => (
                            <option key={month} value={month}>
                              {month}
                            </option>
                          ))}
                        </select>

                        {/* Year Dropdown */}
                        <select
                          style={{
                            fontSize: "16px",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                          }}
                          value={date.getFullYear()}
                          onChange={({ target: { value } }) =>
                            changeYear(value)
                          }
                        >
                          {years.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* âœ… Optional month navigation below */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <button
                          onClick={decreaseMonth}
                          disabled={prevMonthButtonDisabled}
                          style={{
                            fontSize: "18px",
                            padding: "2px 8px",
                            cursor: "pointer",
                          }}
                        >
                          {"<"}
                        </button>

                        <span
                          style={{
                            fontWeight: "bold",
                            fontSize: "16px",
                          }}
                        >
                          {months[date.getMonth()]} {date.getFullYear()}
                        </span>

                        <button
                          onClick={increaseMonth}
                          disabled={nextMonthButtonDisabled}
                          style={{
                            fontSize: "18px",
                            padding: "2px 8px",
                            cursor: "pointer",
                          }}
                        >
                          {">"}
                        </button>
                      </div>
                    </div>
                  );
                }}
              />
              <Form.Control.Feedback type="invalid">
                Anniversary Date is required!
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form.Label>Notes</Form.Label>
              <Form.Control
                // required
                size="sm"
                type="text"
                name="notes"
                id="notes"
                placeholder="Notes"
                value={roasterdData.notes}
                onChange={(e) => handleChangeRoaster(e)}
              />
              <Form.Control.Feedback type="invalid">
                Notes is required!
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form.Label
                className={`${roasterdData.allergies ? "" : "highlightField"}`}
              >
                Do you or your spouse have any dietary allergies, dietary
                restrictions or physical limitations?{" "}
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                required
                size="sm"
                type="text"
                name="allergies"
                id="allergies"
                value={roasterdData.allergies}
                onChange={(e) => handleChangeRoaster(e)}
              />
              <Form.Control.Feedback type="invalid">
                Please provide dietary allergies, dietary restrictions, or any
                physical limitations.
              </Form.Control.Feedback>
            </Form.Group>
          </div>
          </section>

          <section className="rr-couple-section">
            <div className="rr-couple-section-head">
              <span className="rr-couple-section-icon" aria-hidden="true">
                <Phone size={16} />
              </span>
              <div>
                <h3>Emergency Contacts</h3>
                <p>Add at least one person we can call if needed.</p>
              </div>
            </div>
            <div className="row">
              <div className="rr-couple-subhead">Primary contact</div>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <Form.Label
                className={`${
                  roasterdData.emergency_name1 ? "" : "highlightField"
                }`}
              >
                Emergency Name 1<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                // required
                size="sm"
                type="text"
                name="emergency_name1"
                id="emergency_name1"
                placeholder="Name"
                value={roasterdData.emergency_name1}
                onChange={(e) => handleChangeRoaster(e)}
              />
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <Form.Label
                className={`${
                  roasterdData.emergency_relationship1 ? "" : "highlightField"
                }`}
              >
                Emergency Relationship 1<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                // required
                size="sm"
                type="text"
                name="emergency_relationship1"
                id="emergency_relationship1"
                placeholder="Relationship"
                value={roasterdData.emergency_relationship1}
                onChange={(e) => handleChangeRoaster(e)}
              />
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <Form.Label
                className={`${
                  roasterdData.emergency_phone1 ? "" : "highlightField"
                }`}
              >
                Emergency Phone 1<span className="text-danger">*</span>
              </Form.Label>
              <PhoneInput
                name="emergency_phone1"
                value={roasterdData.emergency_phone1}
                onChange={(e) => handleChangeRoaster(e)}
              />
            </Form.Group>

            <div className="rr-couple-subhead is-optional">
              Second contact <span>Optional</span>
            </div>
            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <Form.Label>Emergency Name 2</Form.Label>
              <Form.Control
                // required
                size="sm"
                type="text"
                name="emergency_name2"
                id="emergency_name2"
                placeholder="Name"
                value={roasterdData.emergency_name2}
                onChange={(e) => handleChangeRoaster(e)}
              />
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <Form.Label>Emergency Relationship 2</Form.Label>
              <Form.Control
                // required
                size="sm"
                type="text"
                name="emergency_relationship2"
                id="emergency_relationship2"
                placeholder="Relationship"
                value={roasterdData.emergency_relationship2}
                onChange={(e) => handleChangeRoaster(e)}
              />
              <Form.Control.Feedback type="invalid">
                Relationship is required!
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <Form.Label>Emergency Phone 2</Form.Label>
              <PhoneInput
                name="emergency_phone2"
                value={roasterdData.emergency_phone2}
                onChange={(e) => handleChangeRoaster(e)}
              />
            </Form.Group>
          </div>
          </section>

          <section className="rr-couple-section">
            <div className="rr-couple-section-head">
              <span className="rr-couple-section-icon" aria-hidden="true">
                <Megaphone size={16} />
              </span>
              <div>
                <h3>How they found LoveStrong</h3>
                <p>Optional. Choose every option that applies.</p>
              </div>
            </div>
            <div className="rr-couple-chips">
              <label className="rr-couple-chip">
                <input
                  type="checkbox"
                  className="form-check-input ageLabel"
                  name="Website"
                  value="Website"
                  onChange={(e) => handleCheckboxChange(e, "forRoaster")}
                  checked={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes("Website")
                  }
                  disabled={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes(
                      roasterdData.hear_us === "Website",
                    )
                  }
                />
                Website
                <i className="input-helper"></i>
              </label>

              <label className="rr-couple-chip">
                <input
                  type="checkbox"
                  className="form-check-input ageLabel"
                  name="Church Bulletin"
                  value="Church Bulletin"
                  onChange={(e) => handleCheckboxChange(e, "forRoaster")}
                  checked={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes("Church Bulletin")
                  }
                  disabled={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes(
                      roasterdData.hear_us === "Church Bulletin",
                    )
                  }
                />
                Church Bulletin
                <i className="input-helper"></i>
              </label>

              <label className="rr-couple-chip">
                <input
                  type="checkbox"
                  className="form-check-input ageLabel"
                  name="Facebook"
                  value="Facebook"
                  onChange={(e) => handleCheckboxChange(e, "forRoaster")}
                  checked={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes("Facebook")
                  }
                  disabled={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes(
                      roasterdData.hear_us === "Facebook",
                    )
                  }
                />
                Facebook
                <i className="input-helper"></i>
              </label>

              <label className="rr-couple-chip">
                <input
                  type="checkbox"
                  className="form-check-input ageLabel"
                  name="School Marquee"
                  value="School Marquee"
                  onChange={(e) => handleCheckboxChange(e, "forRoaster")}
                  checked={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes("School Marquee")
                  }
                  disabled={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes(
                      roasterdData.hear_us === "School Marquee",
                    )
                  }
                />
                School Marquee
                <i className="input-helper"></i>
              </label>

              <label className="rr-couple-chip">
                <input
                  type="checkbox"
                  className="form-check-input ageLabel"
                  name="Pulpit Talk/Table in Church"
                  value="Pulpit Talk/Table in Church"
                  onChange={(e) => handleCheckboxChange(e, "forRoaster")}
                  checked={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes("Pulpit Talk/Table in Church")
                  }
                  disabled={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes(
                      roasterdData.hear_us === "Pulpit Talk/Table in Church",
                    )
                  }
                />
                Pulpit Talk/Table in Church
                <i className="input-helper"></i>
              </label>
            </div>
            <Form.Group className="rr-couple-referral">
              <Form.Label htmlFor="referral_from_a_friend_or_family_member">
                Referral from a friend or family member
              </Form.Label>
              <Form.Control
                size="sm"
                type="text"
                name="referral_from_a_friend_or_family_member"
                placeholder="Name of the person who referred them"
                id="referral_from_a_friend_or_family_member"
                value={roasterdData.referral_from_a_friend_or_family_member}
                className="form-control"
                onChange={(e) => {
                  handleChangeRoaster(e);
                }}
              />
            </Form.Group>
          </section>

          <section className="rr-couple-section">
            <div className="rr-couple-section-head">
              <span className="rr-couple-section-icon" aria-hidden="true">
                <ClipboardList size={16} />
              </span>
              <div>
                <h3>Retreat role</h3>
                <p>How this couple participates in this retreat.</p>
              </div>
            </div>
          <Row>
            <Col lg={6} md={6} xs={12}>
              <Form.Group className="form-group col">
                <Form.Label
                  className={
                    roasterdData.attendeeType ? null : "highlightField"
                  }
                >
                  Attendee Type <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  className="form-control minimal"
                  size="sm"
                  type="text"
                  name="attendeeType"
                  id="attendeeType"
                  value={roasterdData && roasterdData.attendeeType}
                  onChange={(e) => handleChangeRoaster(e)}
                  required
                >
                  <option value="">Select Attendee Type</option>
                  <option value="Team">Team</option>
                  <option value="Retreatant">Retreatant</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Attendee Type is required!
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col lg={6} md={6} xs={12}>
              <Form.Group className="form-group col">
                <Form.Label>Role</Form.Label>
                <Form.Select
                  className="form-control minimal"
                  size="sm"
                  type="text"
                  name="roleId"
                  id="roleId"
                  value={roasterdData?.roleId || ""}
                  onChange={(e) => handleChangeRoaster(e)}
                >
                  <option value="">No Role</option>
                  {(() => {
                    const combinedRoles = rolesDataList.filter(
                      (item) =>
                        item.role === "Co-Head" ||
                        item.role === "Head" ||
                        (roasterdData?.roleId &&
                          roasterdData.roleId === item.id),
                    );
                    const uniqueRoles = [
                      ...new Map(
                        combinedRoles.map((item) => [item.id, item]),
                      ).values(),
                    ].sort((a, b) => {
                      if (a.role === "Head") return -1;
                      if (b.role === "Head") return 1;
                      if (a.role === "Co-Head") return -1;
                      if (b.role === "Co-Head") return 1;
                      return 0;
                    });

                    return uniqueRoles.map((item) => (
                      <option key={`role-${item.id}`} value={item.id}>
                        {item.role}
                      </option>
                    ));
                  })()}
                </Form.Select>
              </Form.Group>
            </Col>
            {/* 
              {(() => {
                const selectedRole = rolesDataList.find(
                  (r) => String(r.id) === String(roasterdData?.roleId),
                );
                const isHeadSelected = selectedRole?.role === "Head";
                return isHeadSelected ? (
                  <Col lg={3} md={3} xs={6}>
                    <Form.Group className="form-group col">
                      <Form.Label>Sub-Role</Form.Label>
                      <Form.Select
                        className="form-control minimal"
                        size="sm"
                        name="subRoleId"
                        value={roasterdData?.subRoleId || ""}
                        onChange={(e) => handleChangeRoaster(e)}
                      >
                        <option value="">No Sub-Role</option>
                        {rolesDataList
                          .filter((item) => item.role === "Co-Head")
                          .map((item) => (
                            <option key={`subrole-${item.id}`} value={item.id}>
                              {item.role}
                            </option>
                          ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                ) : null;
              })()} */}

            <Col lg={6} md={6} xs={12}>
              <Form.Group className="form-group col">
                <Form.Label>Service Title</Form.Label>
                <Form.Select
                  className="form-control minimal"
                  size="sm"
                  type="text"
                  name="serviceId"
                  id="serviceId"
                  value={roasterdData && roasterdData.serviceId}
                  onChange={(e) => handleChangeRoaster(e)}
                >
                  <option value="">No Service Title</option>
                  {serviceDataList.length
                    ? serviceDataList.map((item) => {
                        return (
                          <option
                            key={`serviceTitle-${item.id}`}
                            value={item.id}
                          >
                            {item.service}
                          </option>
                        );
                      })
                    : " "}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Service is required!
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col lg={6} md={6} xs={12}>
              <Form.Group className="form-group col">
                <Form.Label>Talk</Form.Label>
                <Form.Select
                  className="form-control minimal"
                  size="sm"
                  name="talkId"
                  id="talkId"
                  value={roasterdData?.talkId ?? ""}
                  onChange={handleChangeRoaster}
                >
                  <option value="">No Talk</option>

                  {talksDataList.map((item) => {
                    const isUsed = assignedTalkIds.includes(
                      Number(item.talkId),
                    );

                    return (
                      <option
                        key={`talk-${item.talkId}`}
                        value={item.talkId}
                        disabled={isUsed}
                      >
                        {item.talk} {isUsed ? "(Already assigned)" : ""}
                      </option>
                    );
                  })}
                </Form.Select>

                <Form.Control.Feedback type="invalid">
                  Talk is required!
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          </section>
          </div>
          )}
        </Modal.Body>
        <Modal.Footer className="rr-couple-footer">
          <p className="rr-couple-footer-note">
            {waitingForExistingCouple
              ? "Select a couple before adding them to this retreat."
              : "Fields marked with * are required."}
          </p>
          <div className="rr-couple-footer-actions">
            <Button
              type="button"
              variant="light"
              className="rr-couple-btn rr-couple-btn--ghost"
              onClick={closeCoupleModal}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              type="submit"
              className={`rr-couple-btn ${
                isNewCouple ? "rr-couple-btn--retreat" : "rr-couple-btn--primary"
              }`}
              disabled={waitingForExistingCouple}
            >
              {isNewCouple ? "Add to Retreat" : "Save Changes"}
            </Button>
          </div>
        </Modal.Footer>
      </Form>
    );

    const renderCoupleRetreatsTab = () => {
      const retreatRows = Array.isArray(roastersOfCoupleList)
        ? roastersOfCoupleList
        : [];
      const retreatLabel = (row) => {
        const language = row?.language
          ? ` (${String(row.language).charAt(0).toUpperCase()}${String(row.language).slice(1)})`
          : "";
        const location = row?.location
          ? ` ${String(row.location).charAt(0).toUpperCase()}${String(row.location).slice(1)}`
          : "";
        return `${row?.parish || "Retreat"}${language}${location}`.trim();
      };
      const retreatDates = (row) => {
        if (!row?.dateFrom) return "";
        if (row.dateFrom === row.dateTo) {
          return moment(row.dateFrom).format("MMM DD, YYYY");
        }
        return `${moment(row.dateFrom).format("MMM DD")} â€“ ${moment(row.dateTo).format("MMM DD, YYYY")}`;
      };

      return (
        <div className="rr-couple-retreats">
          <div className="rr-couple-retreats-count">
            <div>
              <span>Retreats Attended</span>
              <p>Retreats this couple has joined, with their role on each one.</p>
            </div>
            <strong>{roasterCount || retreatRows.length}</strong>
          </div>
          {retreatRows.length === 0 ? (
            <div className="rr-couple-retreats-empty">
              This couple is not on another retreat roster yet.
            </div>
          ) : (
            <ul className="rr-couple-retreat-list">
              {retreatRows.map((row) => {
                const title = retreatLabel(row);
                const dates = retreatDates(row);
                const linked = !(userData && userData.userRole === "SUBADMIN");
                return (
                  <li className="rr-couple-retreat-card" key={row.id || title}>
                    <div className="rr-couple-retreat-main">
                      {linked ? (
                        <a
                          href={`/retreatRoster?retreatId=${row.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {title}
                        </a>
                      ) : (
                        <strong>{title}</strong>
                      )}
                      {dates ? <span>{dates}</span> : null}
                    </div>
                    <dl className="rr-couple-retreat-meta">
                      <div>
                        <dt>Type</dt>
                        <dd>
                          {row?.attendeeType === "Team" ? (
                            <span className="rr-couple-type rr-couple-type--team">
                              {row.attendeeType}
                            </span>
                          ) : row?.attendeeType ? (
                            <span className="rr-couple-type">{row.attendeeType}</span>
                          ) : (
                            <span className="rr-couple-empty-cell">â€”</span>
                          )}
                        </dd>
                      </div>
                      <div>
                        <dt>Role</dt>
                        <dd className={row?.role ? "" : "is-empty"}>
                          {row?.role || "â€”"}
                        </dd>
                      </div>
                      <div>
                        <dt>Service</dt>
                        <dd className={row?.service ? "" : "is-empty"}>
                          {row?.service || "â€”"}
                        </dd>
                      </div>
                      <div>
                        <dt>Talk</dt>
                        <dd className={row?.talk ? "" : "is-empty"}>
                          {row?.talk || "â€”"}
                        </dd>
                      </div>
                    </dl>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      );
    };

    const retreatRecord =
      retreatDetail && typeof retreatDetail === "object" ? retreatDetail : null;
    const retreatName = retreatRecord?.title
      ? retreatRecord.title.charAt(0).toUpperCase() + retreatRecord.title.slice(1)
      : "Retreat";
    const retreatWhen = !retreatRecord?.dateFrom
      ? ""
      : retreatRecord.dateFrom === retreatRecord.dateTo
        ? moment(retreatRecord.dateFrom).format("MMM DD, YYYY")
        : `${moment(retreatRecord.dateFrom).format("MMM DD")} â€“ ${moment(
            retreatRecord.dateTo,
          ).format("MMM DD, YYYY")}`;

    return (
      <Modal
        show={showModel}
        onHide={closeCoupleModal}
        centered
        enforceFocus={false}
        className="rr-couple-modal"
        dialogClassName="rr-couple-dialog"
        contentClassName="rr-couple-content"
        aria-labelledby="rr-couple-modal-title"
      >
        <div className="rr-couple-shell">
          <header className="rr-couple-header">
            <div className="rr-couple-mark" aria-hidden="true">
              {isNewCouple ? <UserPlus size={20} /> : <Users size={20} />}
            </div>
            <div className="rr-couple-header-copy">
              <p className="rr-couple-kicker">Retreat roster</p>
              <h2 id="rr-couple-modal-title">
                {isNewCouple ? "Add a Couple" : "Edit Couple"}
              </h2>
              <p>{[retreatName, retreatWhen].filter(Boolean).join(" Â· ")}</p>
            </div>
            <button
              type="button"
              className="rr-couple-close"
              onClick={closeCoupleModal}
              aria-label="Close"
            >
              <X size={18} />
            </button>
          </header>

          {isNewCouple ? (
            renderRoasterForm()
          ) : (
            <div className="rr-couple-edit">
              <Tabs
                defaultActiveKey="Form"
                id="rr-couple-edit-tabs"
                className="rr-couple-tabs"
              >
                <Tab eventKey="Form" title="Couple Details">
                  {renderRoasterForm()}
                </Tab>
                <Tab eventKey="Retreats" title="Retreats">
                  {renderCoupleRetreatsTab()}
                </Tab>
              </Tabs>
            </div>
          )}
        </div>
      </Modal>
    );
  };

  const serviceData = () => applyFilter("service");
  const rtpData = () => applyFilter("rtp");
  const talkData = () => applyFilter("talk");
  const RetreatData = () => applyFilter("retreatant");
  const spritualData = () => applyFilter("spiritualMentor");
  const leadCoupleData = () => applyFilter("leadCouple");
  const teamData = () => applyFilter("team");

  const collectEmails = (values) => {
    const seen = new Set();
    const list = [];
    values.forEach((email) => {
      const value = typeof email === "string" ? email.trim() : "";
      if (!value) return;
      const key = value.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      list.push(value);
    });
    return list;
  };

  const openFilterMailList = async (event, filterType, label) => {
    event.stopPropagation();
    event.preventDefault();
    try {
      let emails = [];
      if (filterType === "spiritualDirector") {
        const res = await retreatRoastApi.getSpritualDirectorData({
          retreatId,
          isTemp,
        });
        emails = collectEmails([res?.data?.email]);
      } else {
        const res = await retreatRoastApi.getRetreatRoastData({
          pageNo: 1,
          size: 20,
          searchKeyword: "",
          export: true,
          retreatId,
          isTemp,
          filterBy: filterType,
        });
        if (!res.success) {
          toast.error(res.msg || "Could not load emails.");
          return;
        }
        const raw = [];
        (res.data || []).forEach((row) => {
          raw.push(row.hisEmail, row.herEmail);
        });
        emails = collectEmails(raw);
      }
      if (!emails.length) {
        toast.error("No email found.");
        return;
      }
      setCopyMailTitle(label);
      setCopyMailList(emails);
      setCopyMailOpen(true);
    } catch (error) {
      toast.error("Could not load emails.");
    }
  };

  const renderRosterFilterChip = (
    label,
    filterType,
    count,
    active,
    onClick,
    muted = false,
    actionConfig = null,
  ) => (
    <div
      className={`roster-chip${active ? " is-active" : ""}${
        muted ? " is-muted" : ""
      }`}
    >
      <button type="button" className="roster-chip-main" onClick={onClick}>
        <span>{label}</span>
        <span className="roster-chip-count">{count}</span>
      </button>
      <button
        type="button"
        className="roster-chip-mail"
        title={`Copy ${label} emails`}
        onClick={(event) => openFilterMailList(event, filterType, label)}
      >
        <i className="mdi mdi-email-outline" aria-hidden="true" />
      </button>
      {actionConfig ? (
        <button
          type="button"
          className="roster-chip-action"
          title={actionConfig.title}
          onClick={(event) => {
            event.stopPropagation();
            actionConfig.onClick();
          }}
        >
          {typeof actionConfig.icon === "string" ? (
            <i className={actionConfig.icon} aria-hidden="true" />
          ) : (
            actionConfig.icon
          )}
        </button>
      ) : null}
    </div>
  );

  const getRetreatRoastData1 = async (
    pageNo = 1,
    size = 20,
    searchKeyword = null,
    sortBy = {},
    loadCount = false,
  ) => {
    let d = {};
    if (pageNo && size) {
      d.pageNo = pageNo;
      d.size = size;
    }
    // Missing Data is retreat-wide; never scope this fetch to the search box.
    d.searchKeyword = "";
    if (sortBy.sortColumn) {
      d.sortBy = sortBy;
    }
    d.export = true;
    d.retreatId = retreatId;
    d.isTemp = isTemp;
    await retreatRoastApi
      .getRetreatRoastData(d)
      .then((res) => {
        if (res.success) {
          setAllRoasters(res.data);
          const invalidData = res.data.filter(rowMissingRosterRecord);

          setMissingDataLength(invalidData.length);
          setMissingRosterFieldsLength(
            res.data.filter(rowMissingRosterData).length,
          );
          let totalRecords = res.totalRecords ? res.totalRecords : 0;
          let spcount = 0;
          let lccount = 0;
          res.data.map((i) => {
            if (i.mainRole === "Spiritual Mentor") {
              spcount = spcount + 1;
            }
            if (i.mainRole === "Lead") {
              lccount = lccount + 1;
            }
          });
          setSpritual_count(spcount);
          setSpritualDirector_count(
            res?.servTalkTeamTotal?.spiritual_director_count,
          );
          setLead_count(lccount);
          applyRetreatConfirmation(res);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        console.error("There is an error!", error);
        toast.error(error);
      });
  };

  const applyRetreatConfirmation = (res) => {
    if (!res?.confirmation) return;
    let confirmation = res.confirmation;
    if (typeof confirmation === "string") {
      try {
        confirmation = JSON.parse(confirmation);
      } catch (error) {
        return;
      }
    }
    if (!Array.isArray(confirmation)) return;

    retreatDetailRequestId.current += 1;
    setRetreatDetail((prev) => {
      const base = prev && typeof prev === "object" ? prev : {};
      return {
        ...base,
        confirmation,
        ...(res.retreatCloseStatus !== undefined
          ? { retreatCloseStatus: res.retreatCloseStatus }
          : {}),
        ...(Object.prototype.hasOwnProperty.call(res, "confirmedByAdmin")
          ? { confirmedByAdmin: res.confirmedByAdmin }
          : {}),
        ...(Object.prototype.hasOwnProperty.call(res, "directoryFile")
          ? { directoryFile: res.directoryFile }
          : {}),
        ...(Object.prototype.hasOwnProperty.call(res, "programFile")
          ? { programFile: res.programFile }
          : {}),
      };
    });
  };

  const getRetreatDetail = async () => {
    const requestId = ++retreatDetailRequestId.current;
    startLoading();
    await retreatApi
      .getRetreatDetail({ id: retreatId, isTemp: isTemp })
      .then(async (response) => {
        const { schedule, ...rest } = response.data[0];
        const parsedSchedule = schedule ? JSON.parse(schedule) : [];
        const parsedConfirmation = parseConfirmationList(rest.confirmation);
        const parsedData = {
          ...rest,
          confirmation: parsedConfirmation.length
            ? parsedConfirmation
            : rest.confirmation,
          freeze: isTemp ? "UNFREEZE" : rest.freeze,
          schedule: parsedSchedule.map((entry) => ({
            date: new Date(entry.date),
            from: entry.from,
            to: entry.to,
          })),
        };
        setRetreatDetail((prev) => {
          if (
            requestId !== retreatDetailRequestId.current &&
            prev &&
            typeof prev === "object"
          ) {
            const preferFreshClose =
              isFlagOn(parsedData.confirmedByAdmin) ||
              isFlagOn(parsedData.retreatCloseStatus);
            return {
              ...parsedData,
              confirmation: preferFreshClose
                ? parsedData.confirmation ?? prev.confirmation
                : prev.confirmation ?? parsedData.confirmation,
              retreatCloseStatus: preferFreshClose
                ? parsedData.retreatCloseStatus
                : prev.retreatCloseStatus !== undefined
                  ? prev.retreatCloseStatus
                  : parsedData.retreatCloseStatus,
              confirmedByAdmin: preferFreshClose
                ? parsedData.confirmedByAdmin
                : prev.confirmedByAdmin ?? parsedData.confirmedByAdmin,
              directoryFile: prev.directoryFile ?? parsedData.directoryFile,
              programFile: prev.programFile ?? parsedData.programFile,
            };
          }
          return parsedData;
        });
        stopLoading();
      })
      .catch((error) => {
        stopLoading();
        toast.error(error.toString());
      });
  };

  const DeleteData = async () => {
    await retreatRoastApi
      .deleteRetreatRoast({ id: roast_id.id, isTemp })
      .then(async (response) => {
        refreshWithActiveFilter();
        getRetreatRoastData1();
        spritualDirectorData();
        setShow(false);
        setRoast_id("");
        leadCoupleData1();
        toast.success(response.msg);

      })
      .catch((error) => {
        setShow(false);
        setRoast_id("");
        leadCoupleData1();
        toast.error(error.toString());
      });
  };

  const clickOnInputFile = () => {
    document.getElementById("fileUpload").click();
  };

  function isXLSXFile(file) {
    return file.name.endsWith(".xlsx");
  }

  const fileChangeListener = (event) => {
    let files = [];
    files = event.target.files;
    if (files && files.length && isXLSXFile(files[0])) {
      const input = event.target;
      const reader = new FileReader();
      reader.readAsBinaryString(input.files[0]);

      reader.onload = (e) => {
        const xlsxData = reader.result;
        processXLSXContactRecord(xlsxData);
      };
      reader.onerror = function () {
        alert("Unable to read " + input.files[0]);
        toast.error(`Unable to read ${input.files[0]} `);
        // setProcessing(false);
      };
    } else {
      toast.error("Please import valid .xlsx file.");
      // this.errorMsg = "Please import valid .xlsx file.";
      // fileReset();
    }
  };

  const ImportFileHeader = {
    A: "Couple Id",
    B: "Type",
    C: "His Last Name",
    D: "His First Name",
    E: "Her Last Name",
    F: "Her First Name",
    G: "His Email",
    H: "Her Email",
    I: "His Mobile",
    J: "Her Mobile",
    K: "Service Role",
    L: "Service Title",
    M: "Talk",
    N: "Address",
    O: "City",
    P: "State",
    Q: "Zip",
    R: "Parish",
    S: "Anniversary Date",
    T: "Dietary Restrictions Or Physical Limitations",
    U: "Under Age 35",
    V: "Emergency Name1",
    W: "Emergency Relationship1",
    X: "Emergency Phone1",
    Y: "Emergency Name2",
    Z: "Emergency Relationship2",
    AA: "Emergency Phone2",
    AB: "How did you hear about us?",
    AC: "Referral from a friend/family member",
    AD: "Notes",
  };

  const processXLSXContactRecord = (xlsxRecordsArray) => {
    try {
      const workbook = XLSX.read(xlsxRecordsArray, {
        type: "binary",
        cellDates: true,
      });
      const sheet_name_list = workbook.SheetNames;
      const data = [];
      const headers = {};
      sheet_name_list.forEach(function (y) {
        const worksheet = workbook.Sheets[y];
        for (let z in worksheet) {
          if (z[0] === "!") continue;
          let tt = 0;
          for (let i = 0; i < z.length; i++) {
            if (!isNaN(z[i])) {
              tt = i;
              break;
            }
          }
          const col = z.substring(0, tt);
          const row = parseInt(z.substring(tt));
          const value = worksheet[z].v;
          if (row == 1 && value) {
            headers[col] = value.trim();
            continue;
          }
          if (!data[row]) {
            data[row] = {};
          }
          data[row][headers[col]] = value;
        }
      });
      const importFileHeaderKeys = Object.keys(ImportFileHeader).map((key) =>
        key.toUpperCase(),
      );
      const headersKeys = Object.keys(headers).map((key) => key.toUpperCase());

      if (
        JSON.stringify(importFileHeaderKeys) === JSON.stringify(headersKeys)
      ) {
        if (data && data.length) {
          let importedData = [];
          // if (!data[2]["Couple Id"]) {
          //   toast.error("Couple Id Header is missing in Excel");
          //   return false;
          // }

          let typeSpellError = false;

          for (let index = 2; index < data.length; index++) {
            if (data[index].Type != "Team") {
              if (data[index].Type != "Retreatant") {
                typeSpellError = true;
                break;
              }
            }
          }

          if (typeSpellError) {
            toast.error(
              "There is error in 'Type' column. \n Check spelling of 'Retreatant' or 'Team'",
            );
            return;
          } else {
            data.forEach(function (value, index) {
              if (!value || index < 2) return;
              const hasType = value["Type"] && String(value["Type"]).trim();
              const hasData =
                value["His First Name"] ||
                value["Her First Name"] ||
                value["His Email"] ||
                value["Her Email"];
              if (!hasType || !hasData) return;

              const obj = {};
              if (value["Couple Id"] == "") {
                toast.error(
                  "Couple Id value missing. Check near line " + (index + 1),
                );
                return;
              }
              if (value["Couple Id"]) {
                obj.primaryKey = value["Couple Id"] ? value["Couple Id"] : "";
                obj.attendeeType = value["Type"] ? value["Type"] : "";
                obj.hisFirstName = value["His First Name"]
                  ? value["His First Name"]
                  : "";
                obj.hisLastName = value["His Last Name"]
                  ? value["His Last Name"]
                  : "";
                obj.hisEmail = value["His Email"] ? value["His Email"] : "";
                obj.hisMobile = value["His Mobile"] ? value["His Mobile"] : "";
                obj.herFirstName = value["Her First Name"]
                  ? value["Her First Name"]
                  : "";
                obj.herLastName = value["Her Last Name"]
                  ? value["Her Last Name"]
                  : "";
                obj.herEmail = value["Her Email"] ? value["Her Email"] : "";
                obj.herMobile = value["Her Mobile"] ? value["Her Mobile"] : "";
                obj.role = value["Service Role"] ? value["Service Role"] : "";
                obj.service = value["Service Title"]
                  ? value["Service Title"]
                  : "";
                obj.talk = value["Talk"] ? value["Talk"] : "";
                obj.address = value["Address"] ? value["Address"] : "";
                obj.city = value["City"] ? value["City"] : "";
                obj.state = value["State"] ? value["State"] : "";
                obj.zip = value["Zip"] ? value["Zip"] : "";
                obj.parish = value["Parish"] ? value["Parish"] : "";

                obj.anniversary_date = value["Anniversary Date"]
                  ? Helpers.convertUtcToTimezone(
                      value["Anniversary Date"],
                      "MM-DD",
                    )
                  : "";
                obj.allergies = value[
                  "Dietary Restrictions Or Physical Limitations"
                ]
                  ? value["Dietary Restrictions Or Physical Limitations"]
                  : "";
                obj.under_age_35 = value["Under Age 35"]
                  ? value["Under Age 35"]
                  : "";
                obj.emergency_name1 = value["Emergency Name1"]
                  ? value["Emergency Name1"]
                  : "";
                obj.emergency_relationship1 = value["Emergency Relationship1"]
                  ? value["Emergency Relationship1"]
                  : "";
                obj.emergency_phone1 = value["Emergency Phone1"]
                  ? value["Emergency Phone1"]
                  : "";
                obj.emergency_name2 = value["Emergency Name2"]
                  ? value["Emergency Name2"]
                  : "";
                obj.emergency_relationship2 = value["Emergency Relationship2"]
                  ? value["Emergency Relationship2"]
                  : "";
                obj.emergency_phone2 = value["Emergency Phone2"]
                  ? value["Emergency Phone2"]
                  : "";

                obj.hear_us =
                  value["How did you hear about us?"] &&
                  value["How did you hear about us?"] !== ""
                    ? [value["How did you hear about us?"]]
                    : [];

                obj.referral_from_a_friend_or_family_member = value[
                  "Referral from a friend/family member"
                ]
                  ? value["Referral from a friend/family member"]
                  : "";

                obj.notes = value["Notes"] ? value["Notes"] : "";
                obj.retreatId = retreatId;
              } else {
                obj.primaryKey = "";
                obj.attendeeType = value["Type"] ? value["Type"] : "";
                obj.hisFirstName = value["His First Name"]
                  ? value["His First Name"]
                  : "";
                obj.hisLastName = value["His Last Name"]
                  ? value["His Last Name"]
                  : "";
                obj.hisEmail = value["His Email"] ? value["His Email"] : "";
                obj.hisMobile = value["His Mobile"] ? value["His Mobile"] : "";
                obj.herFirstName = value["Her First Name"]
                  ? value["Her First Name"]
                  : "";
                obj.herLastName = value["Her Last Name"]
                  ? value["Her Last Name"]
                  : "";
                obj.herEmail = value["Her Email"] ? value["Her Email"] : "";
                obj.herMobile = value["Her Mobile"] ? value["Her Mobile"] : "";

                obj.role = value["Service Role"] ? value["Service Role"] : "";
                obj.service = value["Service Title"]
                  ? value["Service Title"]
                  : "";
                obj.talk = value["Talk"] ? value["Talk"] : "";
                obj.address = value["Address"] ? value["Address"] : "";
                obj.city = value["City"] ? value["City"] : "";
                obj.state = value["State"] ? value["State"] : "";
                obj.zip = value["Zip"] ? value["Zip"] : "";
                obj.parish = value["Parish"] ? value["Parish"] : "";
                obj.anniversary_date = value["Anniversary Date"]
                  ? Helpers.convertUtcToTimezone(
                      value["Anniversary Date"],
                      "MM-DD",
                    )
                  : "";
                obj.allergies = value[
                  "Dietary Restrictions Or Physical Limitations"
                ]
                  ? value["Dietary Restrictions Or Physical Limitations"]
                  : "";
                obj.under_age_35 = value["Under Age 35"]
                  ? value["Under Age 35"]
                  : "";
                obj.emergency_name1 = value["Emergency Name1"]
                  ? value["Emergency Name1"]
                  : "";
                obj.emergency_relationship1 = value["Emergency Relationship1"]
                  ? value["Emergency Relationship1"]
                  : "";
                obj.emergency_phone1 = value["Emergency Phone1"]
                  ? value["Emergency Phone1"]
                  : "";
                obj.emergency_name2 = value["Emergency Name2"]
                  ? value["Emergency Name2"]
                  : "";
                obj.emergency_relationship2 = value["Emergency Relationship2"]
                  ? value["Emergency Relationship2"]
                  : "";
                obj.emergency_phone2 = value["Emergency Phone2"]
                  ? value["Emergency Phone2"]
                  : "";

                obj.hear_us =
                  value["How did you hear about us?"] &&
                  value["How did you hear about us?"] !== ""
                    ? [value["How did you hear about us?"]]
                    : [];

                obj.referral_from_a_friend_or_family_member = value[
                  "Referral from a friend/family member"
                ]
                  ? value["Referral from a friend/family member"]
                  : "";

                obj.notes = value["Notes"] ? value["Notes"] : "";

                obj.retreatId = retreatId;
              }
              importedData.push(obj);
            });
            saveRetreatRoasterExcel(importedData);
          }
        }
      } else {
        toast.error("Headers are not the same. Please check sample file.");
        return;
      }
    } catch (err) {
      toast.error(err.toString());
    }
  };

  const saveRetreatRoasterExcel = async (importedData) => {
    startLoading();
    const chunkSize = 10000;
    for (let i = 0; i < importedData.length; i += chunkSize) {
      const chunk = importedData.slice(i, i + chunkSize);
      await retreatRoastApi
        .saveRetreatRoasterExcel({ data: chunk, isTemp })
        .then(async (response) => {
          if (response.success) {






            document.getElementById("fileUpload").value = "";
            toast.success("File data imported successfully.");
            refreshWithActiveFilter();
            leadCoupleData1();
            stopLoading();
          } else {
            document.getElementById("fileUpload").value = "";
            toast.error(response.msg);
            refreshWithActiveFilter();
            leadCoupleData1();
            stopLoading();
          }
        })
        .catch((error) => {
          toast.error(error.toString());
          document.getElementById("fileUpload").value = "";
          console.error("There is an error!", error);
        });
    }
  };

  const formatExportRows = (rows) =>
    rows.map((element) => ({
      primaryKey: element.primaryKey,
      attendeeType: element.attendeeType,
      hisLastName: element.hisLastName,
      hisFirstName: element.hisFirstName,
      herLastName: element.herLastName,
      herFirstName: element.herFirstName,
      hisEmail: element.hisEmail,
      herEmail: element.herEmail,
      hisMobile: element.hisMobile,
      herMobile: element.herMobile,
      roleTitle: element.mainRole,
      serviceTitle: element.service,
      talkTitle: element.talk,
      address: element.address,
      city: element.city,
      state: element.state,
      zip: element.zip,
      parish: element.parish,
      parishId: element.uniqueId,
      Anniversary_date:
        element.anniversary_date !== null
          ? Helpers.convertUtcToTimezone(element.anniversary_date, "MM-DD-YYYY")
          : "",
      Dietary_restrictions_or_physical_limitations: element.allergies,
      Under_age_35: element.under_age_35,
      Emergency_name1: element.emergency_name1,
      Emergency_relationship1: element.emergency_relationship1,
      Emergency_phone1: element.emergency_phone1,
      Emergency_name2: element.emergency_name2,
      Emergency_relationship2: element.emergency_relationship2,
      Emergency_phone2: element.emergency_phone2,
      Referral_from_a_friend_or_family_member:
        element.referral_from_a_friend_or_family_member,
      notes: element.notes,
    }));

  const exportHeadings = [
    [
      "Couple Id",
      "Type",
      "His Last Name",
      "His First Name",
      "Her Last Name",
      "Her First Name",
      "His Email",
      "Her Email",
      "His Mobile",
      "Her Mobile",
      "Service Role",
      "Service Title",
      "Talk",
      "Address",
      "City",
      "State",
      "Zip",
      "Parish",
      "Parish ID",
      "Anniversary Date",
      "Dietary Restrictions Or Physical Limitations",
      "Under Age 35",
      "Emergency Name1",
      "Emergency Relationship1",
      "Emergency Phone1",
      "Emergency Name2",
      "Emergency Relationship2",
      "Emergency Phone2",
      "Referral from a friend/family member",
      "Notes",
    ],
  ];

  const getExportFileName = () =>
    (retreatDetail?.title
      ? `${retreatDetail.title.charAt(0).toUpperCase()}${retreatDetail.title.slice(1)} `
      : "Retreat Roster ") +
    (retreatDetail?.dateFrom === retreatDetail?.dateTo
      ? moment(retreatDetail?.dateFrom).format("MMM-DD-YYYY")
      : moment(retreatDetail?.dateFrom).format("MMM DD") +
        " - " +
        moment(retreatDetail?.dateTo).format("MMM DD") +
        ", " +
        moment(retreatDetail?.dateTo).format("YYYY"));

  const fetchAllExportData = async () => {
    const d = {
      pageNo: 1,
      size: 20,
      export: true,
      retreatId,
      isTemp: isTemp,
      filterBy: "",
    };
    const res = await retreatRoastApi.getRetreatRoastData(d);
    if (res.success) return res.data;
    toast.error(res.msg);
    return null;
  };

  const exportByTypeExcel = async (attendeeType) => {
    const allData = await fetchAllExportData();
    if (!allData) return;
    const filtered = allData.filter((r) => r.attendeeType === attendeeType);
    const searchedAndFiltered = handleClientSearch(filtered, searchKey);
    const wb = utils.book_new();
    const ws = utils.json_to_sheet([]);
    utils.sheet_add_aoa(ws, exportHeadings);
    utils.sheet_add_json(ws, formatExportRows(searchedAndFiltered), {
      origin: "A2",
      skipHeader: true,
    });
    utils.book_append_sheet(wb, ws, "Data");
    writeFile(wb, `${getExportFileName()} - ${attendeeType}.xlsx`);
  };
  const exportByTypePdf = async (attendeeType) => {
    const allData = await fetchAllExportData();
    if (!allData) return;
    const filtered = allData.filter((r) => r.attendeeType === attendeeType);
    const searchedAndFiltered = handleClientSearch(filtered, searchKey);

    const doc = new jsPDF("landscape", "pt", "A1");
    doc.setFontSize(15);
    const pdfHeaders = [
      [
        "Couple Id",
        "Type",
        "His Last Name",
        "His First Name",
        "Her Last Name",
        "Her First Name",
        "His Email",
        "Her Email",
        "His Mobile",
        "Her Mobile",
        "Service Role",
        "Service Title",
        "Talk",
        "Address",
        "City",
        "State",
        "Zip",
        "Parish",
        "Parish ID",
        "Anniversary Date",
        "Under Age 35",
        "Emergency Name1",
        "Emergency Relationship1",
        "Emergency Phone1",
        "Emergency Name2",
        "Emergency Relationship2",
        "Emergency Phone2",
        "Referral from a friend/family member",
        "Notes",
      ],
    ];
    const pdfData = searchedAndFiltered.map((element) => [
      element.primaryKey,
      element.attendeeType,
      element.hisLastName,
      element.hisFirstName,
      element.herLastName,
      element.herFirstName,
      element.hisEmail,
      element.herEmail,
      element.hisMobile,
      element.herMobile,
      element.mainRole,
      element.service,
      element.talk,
      element.address,
      element.city,
      element.state,
      element.zip,
      element.parish,
      element.uniqueId,
      element.anniversary_date
        ? Helpers.convertUtcToTimezone(element.anniversary_date, "MM-DD-YYYY")
        : "",
      element.under_age_35,
      element.emergency_name1,
      element.emergency_relationship1,
      element.emergency_phone1,
      element.emergency_name2,
      element.emergency_relationship2,
      element.emergency_phone2,
      element.referral_from_a_friend_or_family_member,
      element.notes,
    ]);
    doc.text(`${attendeeType} Retreat Roster`, 40, 40);
    doc.autoTable({
      startY: 70,
      head: pdfHeaders,
      body: pdfData,
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 3,
        overflow: "linebreak", // keep this
      },
      columnStyles: {
        27: { cellWidth: 250 }, // ðŸ‘ˆ Notes column index (last column)
      },
      headStyles: {
        fillColor: [22, 160, 133],
        textColor: [255, 255, 255],
        fontSize: 8,
      },
      tableWidth: "wrap",
      margin: { left: 40, right: 40 },
    });
    doc.save(`${getExportFileName()} - ${attendeeType}.pdf`);
  };

  const handleExport = async () => {
    let exportData = [];

    if (missingValue) {
      // Use pre-filtered missing data from state
      exportData = retreatRoastData;
    } else {
      // Fetch full data from API
      let d = {
        pageNo: 1,
        size: 20,
        export: true,
        retreatId: retreatId,
        isTemp: isTemp,
        filterBy: "",
      };

      try {
        const res = await retreatRoastApi.getRetreatRoastData(d);
        if (res.success) {
          exportData = res.data;
        } else {
          toast.error(res.msg);
          return;
        }
      } catch (error) {
        toast.error(error);
        return;
      }
    }

    // Format exportData before writing to Excel
    const formattedData = exportData.map((element) => ({
      primaryKey: element.primaryKey,
      attendeeType: element.attendeeType,
      hisLastName: element.hisLastName,
      hisFirstName: element.hisFirstName,
      herLastName: element.herLastName,
      herFirstName: element.herFirstName,
      hisEmail: element.hisEmail,
      herEmail: element.herEmail,
      hisMobile: element.hisMobile,
      herMobile: element.herMobile,
      roleTitle: element.mainRole,
      serviceTitle: element.service,
      talkTitle: element.talk,
      address: element.address,
      city: element.city,
      state: element.state,
      zip: element.zip,
      parish: element.parish,
      parishId: element.uniqueId,
      Anniversary_date:
        element.anniversary_date !== null
          ? Helpers.convertUtcToTimezone(element.anniversary_date, "MM-DD-YYYY")
          : "",
      Dietary_restrictions_or_physical_limitations: element.allergies,
      Under_age_35: element.under_age_35,
      Emergency_name1: element.emergency_name1,
      Emergency_relationship1: element.emergency_relationship1,
      Emergency_phone1: element.emergency_phone1,
      Emergency_name2: element.emergency_name2,
      Emergency_relationship2: element.emergency_relationship2,
      Emergency_phone2: element.emergency_phone2,
      Referral_from_a_friend_or_family_member:
        element.referral_from_a_friend_or_family_member,
      notes: element.notes,
    }));

    const headings = [
      [
        "Couple Id",
        "Type",
        "His Last Name",
        "His First Name",
        "Her Last Name",
        "Her First Name",
        "His Email",
        "Her Email",
        "His Mobile",
        "Her Mobile",
        "Service Role",
        "Service Title",
        "Talk",
        "Address",
        "City",
        "State",
        "Zip",
        "Parish",
        "Parish ID",
        "Anniversary Date",
        "Dietary Restrictions Or Physical Limitations",
        "Under Age 35",
        "Emergency Name1",
        "Emergency Relationship1",
        "Emergency Phone1",
        "Emergency Name2",
        "Emergency Relationship2",
        "Emergency Phone2",
        "Referral from a friend/family member",
        "Notes",
      ],
    ];

    const wb = utils.book_new();
    const ws = utils.json_to_sheet([]);
    utils.sheet_add_aoa(ws, headings);
    utils.sheet_add_json(ws, formattedData, {
      origin: "A2",
      skipHeader: true,
    });
    utils.book_append_sheet(wb, ws, "Data");

    const fileName =
      (retreatDetail?.title
        ? `${retreatDetail.title
            .charAt(0)
            .toUpperCase()}${retreatDetail.title.slice(1)} `
        : "Retreat Roster ") +
      (retreatDetail?.dateFrom === retreatDetail?.dateTo
        ? moment(retreatDetail?.dateFrom).format("MMM-DD-YYYY")
        : moment(retreatDetail?.dateFrom).format("MMM DD") +
          " - " +
          moment(retreatDetail?.dateTo).format("MMM DD") +
          ", " +
          moment(retreatDetail?.dateTo).format("YYYY"));

    writeFile(wb, `${fileName}.xlsx`);
  };

  const exportFlockNotes = async () => {
    let d = {};
    d.pageNo = 1;
    d.size = 20;
    d.export = true;
    d.retreatId = retreatId;
    d.isTemp = isTemp;
    d.filterBy = "";
    await retreatRoastApi
      .getRetreatRoastData(d)
      .then(async (res) => {
        if (res.success) {
          let exportData = [];

          res.data.forEach((element) => {
            // Push his data
            exportData.push({
              firstName: element.hisFirstName,
              lastName: element.hisLastName,
              email: element.hisEmail,
              mobile: element.hisMobile,
            });
            // Push her data
            exportData.push({
              firstName: element.herFirstName,
              lastName: element.herLastName,
              email: element.herEmail,
              mobile: element.herMobile,
            });
          });

          const headings = [["First Name", "Last Name", "Email", "Mobile"]];

          const wb = utils.book_new();
          const ws = utils.json_to_sheet([]);
          utils.sheet_add_aoa(ws, headings);
          utils.sheet_add_json(ws, exportData, {
            origin: "A2",
            skipHeader: true,
          });
          utils.book_append_sheet(wb, ws, "Data");

          writeFile(
            wb,
            `${
              retreatDetail && retreatDetail.title
                ? `${
                    retreatDetail.title.charAt(0).toUpperCase() +
                    retreatDetail.title.slice(1)
                  }` +
                  " " +
                  `${
                    retreatDetail.dateFrom === retreatDetail.dateTo
                      ? moment(retreatDetail.dateFrom).format("MMM-DD-YYYY")
                      : moment(retreatDetail.dateFrom).format("MMM DD") +
                        " - " +
                        moment(retreatDetail.dateTo).format("MMM DD") +
                        ", " +
                        moment(retreatDetail.dateTo).format("YYYY")
                  }`
                : "Retreat Roster"
            }.xlsx`,
          );


        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const exportPdf = async () => {
    const unit = "pt";
    const size = "A1"; // large enough for wide tables
    const orientation = "landscape"; // better for many columns
    const marginLeft = 40;

    const doc = new jsPDF(orientation, unit, size);
    doc.setFontSize(15);
    const title = "All Retreat Roster";

    const headers = [
      [
        "Couple Id",
        "Type",
        "His Last Name",
        "His First Name",
        "Her Last Name",
        "Her First Name",
        "His Email",
        "Her Email",
        "His Mobile",
        "Her Mobile",
        "Service Role",
        "Service Title",
        "Talk",
        "Address",
        "City",
        "State",
        "Zip",
        "Parish",
        "Parish ID",
        "Anniversary Date",
        "Under Age 35",
        "Emergency Name1",
        "Emergency Relationship1",
        "Emergency Phone1",
        "Emergency Name2",
        "Emergency Relationship2",
        "Emergency Phone2",
        "Referral from a friend/family member",
        "Notes",
      ],
    ];

    let exportSource = [];

    if (missingValue) {
      exportSource = retreatRoastData;
    } else {
      let d = {
        pageNo: 1,
        size: 20,
        export: true,
        retreatId: retreatId,
        filterBy: "",
      };

      try {
        const res = await retreatRoastApi.getRetreatRoastData(d);
        if (res.success) {
          exportSource = res.data;
        } else {
          toast.error(res.msg);
          return;
        }
      } catch (error) {
        toast.error(error);
        return;
      }
    }

    // âœ… Removed allergies, referral_from_a_friend_or_family_member, notes
    const data = exportSource.map((element) => [
      element.primaryKey,
      element.attendeeType,
      element.hisLastName,
      element.hisFirstName,
      element.herLastName,
      element.herFirstName,
      element.hisEmail,
      element.herEmail,
      element.hisMobile,
      element.herMobile,
      element.mainRole,
      element.service,
      element.talk,
      element.address,
      element.city,
      element.state,
      element.zip,
      element.parish,
      element.uniqueId,
      element.anniversary_date
        ? Helpers.convertUtcToTimezone(element.anniversary_date, "MM-DD-YYYY")
        : "",
      element.under_age_35,
      element.emergency_name1,
      element.emergency_relationship1,
      element.emergency_phone1,
      element.emergency_name2,
      element.emergency_relationship2,
      element.emergency_phone2,
      element.referral_from_a_friend_or_family_member,
      element.notes,
    ]);

    const content = {
      startY: 70,
      head: headers,
      body: data,
      theme: "grid",
      styles: {
        fontSize: 9,
        cellPadding: 3,
        overflow: "linebreak",
        cellWidth: "wrap",
      },
      headStyles: {
        fillColor: [22, 160, 133],
        textColor: [255, 255, 255],
        fontSize: 9,
      },
      columnStyles: {
        0: { cellWidth: 60 },
        1: { cellWidth: 50 },
        2: { cellWidth: 80 },
        3: { cellWidth: 80 },
        4: { cellWidth: 80 },
        5: { cellWidth: 80 },
        6: { cellWidth: 120 },
        7: { cellWidth: 120 },
        8: { cellWidth: 80 },
        9: { cellWidth: 80 },
        10: { cellWidth: 80 },
        11: { cellWidth: 80 },
        12: { cellWidth: 80 },
        13: { cellWidth: 100 },
        14: { cellWidth: 60 },
        15: { cellWidth: 60 },
        16: { cellWidth: 50 },
        17: { cellWidth: 80 },
        18: { cellWidth: 60 },
        19: { cellWidth: 60 },
        20: { cellWidth: 80 },
        21: { cellWidth: 80 },
        22: { cellWidth: 80 },
        23: { cellWidth: 90 },
        24: { cellWidth: 80 },
        25: { cellWidth: 90 },
        26: { cellWidth: 90 },
        27: {
          cellWidth: 250,
          overflow: "linebreak",
        },
      },
      tableWidth: "wrap",
      margin: { left: marginLeft, right: 40 },
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);

    const fileName =
      (retreatDetail?.title
        ? `${retreatDetail.title
            .charAt(0)
            .toUpperCase()}${retreatDetail.title.slice(1)} `
        : "Retreat Roster ") +
      (retreatDetail?.dateFrom === retreatDetail?.dateTo
        ? moment(retreatDetail?.dateFrom).format("MMM-DD-YYYY")
        : moment(retreatDetail?.dateFrom).format("MMM DD") +
          " - " +
          moment(retreatDetail?.dateTo).format("MMM DD") +
          ", " +
          moment(retreatDetail?.dateTo).format("YYYY"));

    doc.save(`${fileName}.pdf`);
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip">{props}</Tooltip>
  );

  const SearchData = (event) => {
    const key = event.target.value;
    setSearchKey(key);
    // Always use server-side fetching, passing null for arg5 to let it use activeFilterRef/State
    getRetreatRoastData(1, 20, key);
    if (!key.trim()) {
      getRetreatRoastData1(1, 20, "");
    }
  };

  const downloadSampleExcel = async () => {
    const headings = [
      [
        "Couple Id",
        "Type",
        "His Last Name",
        "His First Name",
        "Her Last Name",
        "Her First Name",
        "His Email",
        "Her Email",
        "His Mobile",
        "Her Mobile",
        "Service Role",
        "Service Title",
        "Talk",
        "Address",
        "City",
        "State",
        "Zip",
        "Parish",
        "Anniversary Date",
        "Dietary Restrictions Or Physical Limitations",
        "Under Age 35",
        "Emergency Name1",
        "Emergency Relationship1",
        "Emergency Phone1",
        "Emergency Name2",
        "Emergency Relationship2",
        "Emergency Phone2",
        "How did you hear about us?",
        "Referral from a friend/family member",
        "Notes",
      ],
    ];
    const data = [
      {
        primaryKey: "001",
        type: "Team",
        hisLastName: "Paul",
        hisFirstName: "Sam",
        herLastName: "Paul",
        herFirstName: " Charisse",
        hisEmail: "sampaul@gmail.com",
        herEmail: "charisseAdams@gmail.com",
        hisMobile: "210-323-0384",
        herMobile: "210-459-4955",
        role: "Co-Head Couple",
        service: "Kitchen",
        talk: "Children and In-Laws",
        address: "101 Balistreri Overpass, Cummerataland, KY 42976",
        city: "Los Angeles",
        state: "California",
        zip_code: "123456",
        parish: "Holy Spirit",
        ainniversary_date: "04-02-2000",
        dietary_restrictions_or_physical_limitations:
          "Dietary restrictions or physical limitations",
        under_age_35: "NO",
        emergency_name_1: "cris",
        emergency_relationship_1: "friend",
        emergency_phone_1: "6445-7645-6786",
        emergency_name_2: "Eric",
        emergency_relationship_2: "Broother",
        emergency_phone_2: "1425-7645-6786",
        hear_about_us: ["School Marquee", "Facebook"],
        Referral_from_a_friend_or_Family_member: "sister",
        notes: "Your notes here.",
      },
      {
        primaryKey: "002",
        type: "Retreatant",
        hisLastName: "Sparow",
        hisFirstName: "Tom",
        herLastName: "Sparow",
        herFirstName: " Zean",
        hisEmail: "tom@gmail.com",
        herEmail: "zean@gmail.com",
        hisMobile: "540-723-0384",
        herMobile: "110-454-4957",
        role: "Lead",
        service: "Music",
        talk: "Marital Bliss",
        address: "Tata Nagar, Opp:ashok Tea House, Deonar (east)",
        city: "Nanwanling	China",
        state: "Tennessee",
        zip_code: "5654756",
        parish: "Holy Spirit",
        ainniversary_date: "07-11-2010",
        dietary_restrictions_or_physical_limitations:
          "Autoimmunity-Immune Deficiency.",
        under_age_35: "NO",
        emergency_name_1: "norman",
        emergency_relationship_1: "father",
        emergency_phone_1: "5656-5657-6786",
        emergency_name_2: "bilosh",
        emergency_relationship_2: "Mother",
        emergency_phone_2: "1425-7645-6786",
        hear_about_us: ["Facebook"],
        Referral_from_a_friend_or_Family_member: "Unle",
        notes: "Your second notes here111.",
      },

      {
        primaryKey: "003",
        type: "Retreatant",
        hisLastName: "Alanis",
        hisFirstName: "Arnulfo",
        herLastName: "Alanis",
        herFirstName: "Millie",
        hisEmail: "arnulfo@gmail.com",
        herEmail: "millie@gmail.com",
        hisMobile: "560-723-4384",
        herMobile: "870-154-4957",
        role: "",
        service: "",
        talk: "",
        address: "Suite 687 3380 Liane Port, Harberberg, OH 95790",
        city: "Nanwanling	China",
        state: "Tennessee",
        zip_code: "5654756",
        parish: "Sts. Peter and Paul",
        ainniversary_date: "07-11-2015",
        dietary_restrictions_or_physical_limitations: "Sinusitis",
        under_age_35: "YES",
        emergency_name_1: "vintrel",
        emergency_relationship_1: "Friend",
        emergency_phone_1: "566-5657-6786",
        emergency_name_2: "orbio",
        emergency_relationship_2: "",
        emergency_phone_2: "3232-7645-6786",
        hear_about_us: ["Facebook", "Church Bulletin"],
        Referral_from_a_friend_or_Family_member: "Unle",
        notes: "Your second notes here111.",
      },

      {
        primaryKey: "004",
        type: "Retreatant",
        hisLastName: "Jamson",
        hisFirstName: "Beon",
        herLastName: "Jamson",
        herFirstName: "Khalisi",
        hisEmail: "beos@gmail.com",
        herEmail: "khalisi@gmail.com",
        hisMobile: "560-723-4384",
        herMobile: "980-154-2957",
        role: "Team Member",
        service: "Tables",
        talk: "Communication",
        address: "Tata Nagar, Opp:ashok Tea House, Deonar (east)",
        city: "Nanwanling	China",
        state: "Tennessee",
        zip_code: "5654756",
        parish: "Holy Spirit",
        ainniversary_date: "07-11-2013",
        dietary_restrictions_or_physical_limitations: "ledi 11 nirmal",
        under_age_35: "NO",
        emergency_name_1: "wisel",
        emergency_relationship_1: "father",
        emergency_phone_1: "5656-5657-6786",
        emergency_name_2: "dekip",
        emergency_relationship_2: "Mother",
        emergency_phone_2: "7878-7645-6786",
        hear_about_us: ["Church Bulletin"],
        Referral_from_a_friend_or_Family_member: "Aunty",
        notes: "Your third notes here111.",
      },
    ];
    const wb = utils.book_new();
    const ws = utils.json_to_sheet([]);
    utils.sheet_add_aoa(ws, headings);
    utils.sheet_add_json(ws, data, { origin: "A2", skipHeader: true });
    utils.book_append_sheet(wb, ws, "Data");
    writeFile(wb, "Sample RetreatRoster File.xlsx");

  };

  const popover = (row) => {
    return (
      <Popover id="popover-ImgPk" bsPrefix="popover">
        <Popover.Body>
          <div style={{ textAlign: "center", padding: "10px 0px" }}>
            {row.imageUrl ? (
              <span>
                <img
                  src={row.imageUrl}
                  className="column-rowImagePopover"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = corruptedImg;
                  }}
                />
              </span>
            ) : (
              <img src={Profile} className="column-rowImagePopover" />
            )}
            <h6 className="couplename">
              {" "}
              {row &&
                row.hisLastName +
                  ", " +
                  row.hisFirstName +
                  " and " +
                  row.herFirstName}
            </h6>
          </div>
        </Popover.Body>
      </Popover>
    );
  };

  const editRoast = async (row) => {
    const lockedEmails = [
      "tkolkebeck@me.com",
      "tkolkebeck@satx.rr.com",
      "jimmieflores@gmail.com",
      "dulceaflores@gmail.com",
    ];
    setIsNewCouple(false);
    setValidated(false);
    setEmailErrors({});
    setIsTempUpload(false);
    setCoupleEntryMode("new");
    setExistingCoupleOption(null);
    setIsEditAdmin(
      lockedEmails.includes(row?.hisEmail) ||
        lockedEmails.includes(row?.herEmail),
    );
    setStates(row);
    setOldValues(row);
    setShowModel(true);
    getroastersOfCouple(row.coupleId);

  };

  const showActionColumn =
    userData?.userRole === "ADMIN" ||
    (userData?.userRole !== "ADMIN" &&
      retreatDetail &&
      userData?.committeeMember === true &&
      !retreatDetail?.retreatCloseStatus) ||
    (userData?.userRole !== "ADMIN" &&
      retreatDetail &&
      userData?.access === true &&
      userData?.isDisabled === 0 &&
      !retreatDetail?.retreatCloseStatus);

  retreatParishIdRef.current = retreatDetail?.parishId ?? null;

  const rosterMissingStyles = (field) => [
    {
      when: (row) =>
        isRosterCellMissing(row, field, retreatParishIdRef.current),
      style: {
        backgroundColor: "#ffff00",
        color: "#111827",
      },
    },
  ];

  const renderRosterTableCell = (field, originalCell) =>
    (row, index, column, id) => {
      if (isRosterCellMissing(row, field, retreatParishIdRef.current)) {
        return (
          <span className="rr-roster-missing-text" title="Missing roster data">
            {ROSTER_MISSING_LABEL}
          </span>
        );
      }
      return originalCell ? originalCell(row, index, column, id) : row[field];
    };

  const renderMissingDataLegend = () => (
    <div className="rr-roster-missing-note">
      <button
        type="button"
        className={`rr-roster-btn rr-roster-btn--missing${
          missingValue ? " is-active" : ""
        }`}
        onClick={missingData}
      >
        {`Missing Data (${missingDataLength || 0} ${
          missingDataLength == "1" ? "Record" : "Records"
        })`}
      </button>
      <span className="rr-roster-missing-swatch" aria-hidden="true">
        ⚠ Missing
      </span>
      Yellow means missing Roster data
    </div>
  );

  const columns = [
    {
      id: "action",
      name: "Action",
      button: true,
      cell: (row) => (
        <>
          {showActionColumn && (
            <>
              <button
                disabled={row && row.freeze == "FREEZE" ? true : false}
                className="font-size"
                onClick={() => {
                  editRoast(row);
                }}
              >
                <i
                  className={`mdi mdi-pencil-box text-lg ${
                    row && row.freeze === "FREEZE"
                      ? "editRetreatDisabled"
                      : "editRetreatButton"
                  } font-size`}
                  title="Edit"
                ></i>
              </button>
              <button
                disabled={row && row.freeze == "FREEZE" ? true : false}
                className="font-size"
                onClick={() => {
                  handleShow(row);
                  setRoasterdData("");
                }}
              >
                <i
                  className={`mdi mdi-delete-forever text-md  ${
                    row && row.freeze === "FREEZE"
                      ? "deleteRetreatDisabled"
                      : "deleteRetreatButton"
                  } mx-2 font-size`}
                  title="Delete"
                ></i>
              </button>
            </>
          )}
          <CopyEmailsButton emails={[row.hisEmail, row.herEmail]} />
        </>
      ),
      reorder: true,
      width: showActionColumn ? "140px" : "70px",
    },

    {
      id: "primaryKey",
      name: "Couple Id",
      selector: (row) => row.primaryKey,
      cell: (row) => (
        <>
          {(row.mainRole == "Spiritual Mentor" && (
            <span className="line2"></span>
          )) ||
            (row.mainRole == "Lead" && <span className="line1"></span>) ||
            (row.attendeeType == "Team" && <span className="line4"></span>) ||
            (row.attendeeType == "Retreatant" && (
              <span className="line3"></span>
            )) || <span className="line5"></span>}
          <OverlayTrigger
            placement="right"
            // delay={{ show: 250, hide: 400 }}
            overlay={popover(row)}
          >
            {/* <span>{row.primaryKey}</span> */}
            {row.imageUrl ? (
              <span
                onClick={
                  shouldHideUI || (row && row.freeze === "FREEZE")
                    ? undefined
                    : () => editRoast(row)
                }
                style={{
                  cursor:
                    shouldHideUI || (row && row.freeze === "FREEZE")
                      ? "default"
                      : "pointer",
                }}
              >
                <span className="roasterKey">
                  <img
                    src={row.imageUrl}
                    className="column-rowImage"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = corruptedImg;
                    }}
                  />
                </span>
                {row.primaryKey ? <span className="pk-id">{row.primaryKey}</span> : null}
              </span>
            ) : (
              <span
                onClick={
                  shouldHideUI || (row && row.freeze === "FREEZE")
                    ? undefined
                    : () => editRoast(row)
                }
                style={{
                  cursor:
                    shouldHideUI || (row && row.freeze === "FREEZE")
                      ? "default"
                      : "pointer",
                }}
              >
                <span className="roasterKey is-roster-missing">
                  <img src={Profile} className="column-rowImage-profile" />
                </span>
                {row.primaryKey ? <span className="pk-id">{row.primaryKey}</span> : null}
              </span>
            )}
          </OverlayTrigger>
        </>
      ),
      sortable: true,
      reorder: true,
      width: "200px",
    },
    {
      id: "Retreatant",
      name: "Type",
      selector: (row) =>
        row && row.attendeeType !== null ? row.attendeeType : "",
      reorder: true,
      sortable: true,
      width: "120px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "his Last Name",
      name: "His Last Name",
      selector: (row) => row.hisLastName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.hisLastName)}
        >
          <span
            onClick={
              shouldHideUI
                ? undefined
                : () => {
                    editCouple(row.coupleId);
                    setShowREgModal(true);
                    getroastersOfCouple(row.coupleId);
                  }
            }
            style={{ cursor: shouldHideUI ? "default" : "pointer" }}
          >
            {row.hisLastName}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
    },
    {
      id: "his First Name",
      name: "His First Name",
      selector: (row) => row.hisFirstName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.hisFirstName)}
        >
          <span
            onClick={
              shouldHideUI
                ? undefined
                : () => {
                    editCouple(row.coupleId);
                    setShowREgModal(true);
                    getroastersOfCouple(row.coupleId);
                  }
            }
            style={{ cursor: shouldHideUI ? "default" : "pointer" }}
          >
            {row.hisFirstName}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
    },
    {
      id: "Her Last Name",
      name: "Her Last Name",
      selector: (row) => row.herLastName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.herLastName)}
        >
          <span
            onClick={
              shouldHideUI
                ? undefined
                : () => {
                    editCouple(row.coupleId);
                    setShowREgModal(true);
                    getroastersOfCouple(row.coupleId);
                  }
            }
            style={{ cursor: shouldHideUI ? "default" : "pointer" }}
          >
            {row.herLastName}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
    },
    {
      id: "her First Name",
      name: "Her First Name	",
      selector: (row) => row.herFirstName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.herFirstName)}
        >
          <span
            onClick={
              shouldHideUI
                ? undefined
                : () => {
                    editCouple(row.coupleId);
                    setShowREgModal(true);
                    getroastersOfCouple(row.coupleId);
                  }
            }
            style={{ cursor: shouldHideUI ? "default" : "pointer" }}
          >
            {row.herFirstName}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
    },
    {
      id: "His Email",
      name: "His Email",
      selector: (row) => row.hisEmai,
      cell: (row) => (
        <div className="d-flex align-items-center gap-1 w-100">
          <CopyIcon text={row.hisEmail} />
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip(row && row.hisEmail)}
          >
            <span>
              {row.hisEmail &&
                row.hisEmail.slice(0, 15) +
                  (row.hisEmail.length > 15 ? "..." : "")}
            </span>
          </OverlayTrigger>
        </div>
      ),
      sortable: true,
      reorder: true,
      width: "160px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Her Email",
      name: "Her Email",
      selector: (row) => row.herEmail,
      cell: (row) => (
        <div className="d-flex align-items-center gap-1 w-100">
          <CopyIcon text={row.herEmail} />
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip(row && row.herEmail)}
          >
            <span>
              {row.herEmail &&
                row.herEmail.slice(0, 15) +
                  (row.herEmail.length > 15 ? "..." : "")}
            </span>
          </OverlayTrigger>
        </div>
      ),
      sortable: true,
      reorder: true,
      width: "160px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "His Mobile",
      name: "His Mobile",
      selector: (row) => row.hisMobile,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row && row.hisMobile)}
        >
          <span>{row.hisMobile}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Her Mobile",
      name: "Her Mobile",
      selector: (row) => row.herMobile,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row && row.herMobile)}
        >
          <span>{row.herMobile}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Address",
      name: "Address",
      selector: (row) => row.address,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.address)}
        >
          <span>
            {row.address &&
              row.address.slice(0, 10) + (row.address.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Parish",
      name: "Parish",
      selector: (row) => (row && row.parish !== null ? row.parish : ""),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row && row.parish)}
        >
          <span>{row && row.parish}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "200px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "uniqueId",
      name: "Parish ID",
      selector: (row) => (row && row.uniqueId !== null ? row.uniqueId : ""),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row && row.uniqueId)}
        >
          <span>{row && row.uniqueId}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "200px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Role",
      name: "Service Role",
      selector: (row) => (row && row.mainRole !== null ? row.mainRole : ""),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.mainRole)}
        >
          <span>{row.mainRole}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "130px",
      style: {
        cursor: "text",
      },
    },
    // {
    //   id: "subRole",
    //   name: "Sub-Role",
    //   selector: (row) => (row && row.subRole !== null ? row.subRole : ""),
    //   cell: (row) => (
    //     <OverlayTrigger
    //       placement="bottom"
    //       delay={{ show: 250, hide: 400 }}
    //       overlay={renderTooltip(row.subRole)}
    //     >
    //       <span>{row.subRole}</span>
    //     </OverlayTrigger>
    //   ),
    //   sortable: true,
    //   reorder: true,
    //   width: "130px",
    //   style: {
    //     cursor: "text",
    //   },
    // },
    {
      id: "Service",
      name: "Service Title",
      selector: (row) => (row && row.service !== null ? row.service : ""),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.service)}
        >
          <span>{row.service}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Talk",
      name: "Talk",
      selector: (row) => (row && row.talk !== null ? row.talk : ""),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.talk)}
        >
          <span>{row.talk}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "190px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "city",
      name: "City",
      selector: (row) => row.city,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.city)}
        >
          <span>
            {row.city &&
              row.city.slice(0, 10) + (row.city.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "state",
      name: "State",
      selector: (row) => row.state,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.state)}
        >
          <span>
            {row.state &&
              row.state.slice(0, 10) + (row.state.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "zip",
      name: "Zip",
      selector: (row) => row.zip,
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Anniversary Date",
      name: "Anniversary Date",
      selector: (row) =>
        Helpers.convertUtcToTimezone(row.anniversary_date, "M/D/YYYY"),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            Helpers.convertUtcToTimezone(row.anniversary_date, "M/D/YYYY"),
          )}
        >
          <span>
            {row.anniversary_date
              ? Helpers.convertUtcToTimezone(row.anniversary_date, "M/D/YYYY")
              : "--"}
          </span>
        </OverlayTrigger>
      ),
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    /*{
      id: "Dietary restrictions or physical limitations",
      name: "Dietary restrictions or physical limitations",
      selector: (row) => row.allergies,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.allergies)}
        >
          <span>
            {row.allergies &&
              row.allergies.slice(0, 10) +
                (row.allergies.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Emergency Name1",
      name: "Emergency Name1",
      selector: (row) => row.emergency_name1,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.emergency_name1)}
        >
          <span>
            {row.emergency_name1 &&
              row.emergency_name1.slice(0, 12) +
                (row.emergency_name1.length > 12 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Emergency Relationship1",
      name: "Emergency Relationship1",
      selector: (row) => row.emergency_relationship1,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.emergency_relationship1)}
        >
          <span>
            {row.emergency_relationship1 &&
              row.emergency_relationship1.slice(0, 12) +
                (row.emergency_relationship1.length > 12 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Emergency Phone1",
      name: "Emergency Phone1",
      selector: (row) => row.emergency_phone1,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.emergency_phone1)}
        >
          <span>
            {row.emergency_phone1 &&
              row.emergency_phone1.slice(0, 12) +
                (row.emergency_phone1.length > 12 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Emergency Name2",
      name: "Emergency Name2",
      selector: (row) => row.emergency_name2,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.emergency_name2)}
        >
          <span>
            {row.emergency_name2 &&
              row.emergency_name2.slice(0, 12) +
                (row.emergency_name2.length > 12 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Emergency Relationship2",
      name: "Emergency Relationship2",
      selector: (row) => row.emergency_relationship2,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.emergency_relationship2)}
        >
          <span>
            {row.emergency_relationship2 &&
              row.emergency_relationship2.slice(0, 12) +
                (row.emergency_relationship2.length > 12 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Emergency Phone2",
      name: "Emergency Phone2",
      selector: (row) => row.emergency_phone2,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.emergency_phone2)}
        >
          <span>
            {row.emergency_phone2 &&
              row.emergency_phone2.slice(0, 12) +
                (row.emergency_phone2.length > 12 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Hear about us",
      name: "Hear about us",
      selector: (row) => row.hear_us,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            row.hear_us &&
              row.hear_us
                .slice(2, -2)
                .split('","')
                .map((source) => source.replace(/\\"/g, ""))
                .join(", ")
          )}
        >
          <span>
            {row.hear_us &&
              row.hear_us
                .slice(2, -2)
                .split('","')
                .map((source) => source.replace(/\\"/g, ""))
                .join(", ")
                .slice(0, 12) + (row.hear_us.length > 12 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Referral from a friend/Family member",
      name: "Referral from a friend/Family member",
      selector: (row) => row.referral_from_a_friend_or_family_member,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.referral_from_a_friend_or_family_member)}
        >
          <span>
            {row.referral_from_a_friend_or_family_member &&
              row.referral_from_a_friend_or_family_member.slice(0, 12) +
                (row.referral_from_a_friend_or_family_member.length > 12
                  ? "..."
                  : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Under Age 35",
      name: "Under Age 35",
      selector: (row) => row.under_age_35,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.under_age_35)}
        >
          <span>
            {row.under_age_35 &&
              row.under_age_35.slice(0, 12) +
                (row.under_age_35.length > 12 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "notes",
      name: "Notes",
      selector: (row) => row.notes,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.notes)}
        >
          <span>
            {row.notes &&
              row.notes.slice(0, 10) + (row.notes.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },*/
    {
      id: "created",
      name: "Created",
      selector: (row) =>
        Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY hh:mm:a"),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY hh:mm:a"),
          )}
        >
          <span>
            {Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY hh:mm:a")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "170px",
      style: {
        cursor: "text",
      },
    },
  ].map((column) => {
    const field = ROSTER_TABLE_FIELDS[column.id];
    if (!field) return column;
    return {
      ...column,
      conditionalCellStyles: rosterMissingStyles(field),
      cell: renderRosterTableCell(field, column.cell),
    };
  });

  const retreatClose = () => {
    retreatApi
      .retreatCloseStatus({
        retreatId: retreatDetail.id,
        userData,
      })
      .then((res) => {
        if (res.success) {
          toast.success(res.message);
          getRetreatDetail();
          closeStatusAlert();
        } else {
          toast.error(res.message);
        }
      })
      .catch((error) => {
        console.log("error---->", error);

        toast.error("Failed to update retreat status.", error);
      });
  };

  const mailSend = () => {
    retreatApi
      .retreatCloseMailSent({
        retreatId: retreatDetail.id,
        userData: {
          firstName: userData?.firstName,
          lastName: userData?.lastName,
          userName: userData?.userName,
          email: userData?.email,
          userRole: userData?.userRole,
        },
      })
      .then((res) => {
        if (res.success) {
          toast.success(res.message);
          getRetreatDetail();
          closeSendMailAlert();
        } else {
          toast.error(res.message);
        }
      })
      .catch((error) => {
        console.log("error---->", error);
        toast.error("Failed to update retreat status.", error);
      });
  };

  const openSendMailAlert = () => {
    if (isFlagOn(retreatDetail.confirmedByAdmin)) {
      toast.warn("Already confirmed this Retreat.");
    } else {
      setMailSendStatus(true);
    }
  };

  const closeSendMailAlert = () => {
    setMailSendStatus(false);
  };

  const openStatusAlert = () => {
    setStatusCheck(true);
  };

  const closeStatusAlert = () => {
    setStatusCheck(false);
  };

  const missingData = () => {
    const invalidData = allRoasters.filter(rowMissingRosterRecord);
    setAllRoasters(invalidData);
    const displayData = handleClientSearch(invalidData, searchKey);
    setRetreatRoastData(displayData);
    setTotal(displayData.length);
    setMissingValue(true);
  };

  const handleUploadProgram = (retreat) => {
    setSelectedRowId(retreat.id);
    setUploadModalTitle(retreat.title);
    setFileType("programFile");
    setShowUploadModal(true);
    setExistingFileUrl(retreat.programFile);
  };

  const handleUploadDirectory = (retreat) => {
    setSelectedRowId(retreat.id);
    setUploadModalTitle(retreat.title);
    setFileType("directoryFile");
    setShowUploadModal(true); // Show the upload modal
    setExistingFileUrl(retreat.directoryFile);
  };

  const handleUploadModalClose = () => {
    setShowUploadModal(false);
    setSelectedRowId(null); // Reset the row ID(Retreat Id)
    setFileType("");
    setExistingFileUrl("");
    setUploadModalTitle("");
    Promise.all([getRetreatRoastData(""), getRetreatRoastData1()]).finally(
      () => {
        getRetreatDetail();
      },
    );
  };

  const handleUploadSuccess = () => {
    getRetreatDetail();
  };

  const handleDeleteFile = () => {
    setExistingFileUrl(null);
    getRetreatDetail();
  };

  const openPopUpSendFile = async (type = "directory") => {
    setSendFileType(type);
    setSendFile(true);
    let d = {
      pageNo: 1,
      size: 20,
      export: true,
      retreatId: retreatId,
      filterBy: "",
    };
    try {
      const res = await retreatRoastApi.getRetreatRoastData(d);
      if (res.success) {
        setRetreatRoastData(res.data);
        setAllRoasters(res.data);
      } else {
        toast.error(res.msg);
        return;
      }
    } catch (error) {
      toast.error(error);
      return;
    }
  };

  const sendDirProgFile = async ({ recipientTypes, recipientIds }) => {
    setFileSendLoader(true);
    const selectedSendTo = recipientTypes || [];
    let newRetreatRoaster = [];
    const recipientIdSet =
      recipientIds && Array.isArray(recipientIds)
        ? new Set(recipientIds)
        : new Set();

    // selectedSendTo is now an array: ["Retreatant"], ["Team"], or ["Retreatant", "Team"]
    if (recipientIdSet.size > 0) {
      newRetreatRoaster = allRoasters.filter((item) =>
        recipientIdSet.has(item.id),
      );
    } else if (selectedSendTo.length === 2) {
      // Both selected - send to all
      newRetreatRoaster = allRoasters;
    } else if (selectedSendTo.includes("Team")) {
      // Only Team selected
      newRetreatRoaster = allRoasters.filter((item) => {
        return item.attendeeType === "Team";
      });
    } else if (selectedSendTo.includes("Retreatant")) {
      // Only Retreatant selected
      newRetreatRoaster = allRoasters.filter((item) => {
        return item.attendeeType === "Retreatant";
      });
    }

    if (!selectedSendTo.length) {
      toast.error("Please select at least one recipient type");
      setFileSendLoader(false);
      return;
    }

    if (!newRetreatRoaster.length) {
      toast.error("No recipients found");
      setFileSendLoader(false);
      return;
    }

    await directoryApi
      .sendDirProgMail({
        retreatDetail: retreatDetail,
        sendTo: selectedSendTo.join(" and "), // "Retreatant and Team" or just one
        retreatRoaster: newRetreatRoaster,
        fileType: sendFileType,
      })
      .then((res) => {
        if (res.success) {
          closePopUpSendFile();
          toast.success(res.msg);
          setFileSendLoader(false);
        } else {
          toast.error(res.msg);
          setFileSendLoader(false);
        }
      })
      .catch((error) => {
        toast.error(error.message || "An error occurred");
        setFileSendLoader(false);
      });
  };

  const closePopUpSendFile = () => {
    setSendFile(false);
    setSendFileType("directory");
  };

  // ------------------------------------------------------------
  // Retreat admin (sub-admin) management
  // ------------------------------------------------------------
  function formatLabel(firstName, lastName, email) {
    let namePart = "";
    if (lastName) namePart += lastName;
    if (firstName) namePart += (lastName ? ", " : "") + firstName;
    return namePart ? `${namePart} - ${email}` : email;
  }

  const getAllCouples = async () => {
    await adminApi
      .allCouples()
      .then(async (res) => {
        if (res.success) {
          let allcoupleList = [];
          let allMailcoupleList = [];

          res.data &&
            res.data.forEach((item) => {
              if (item.hisFirstName || item.hisLastName || item.herFirstName) {
                const emails = [item.hisEmail, item.herEmail]
                  .filter(Boolean)
                  .join(" & ");

                allcoupleList.push({
                  label: formatCoupleOptionLabel(item),
                  value: item.id,
                });
              }

              if (item.hisEmail) {
                allMailcoupleList.push({
                  label: formatLabel(
                    item.hisFirstName,
                    item.hisLastName,
                    item.hisEmail,
                  ),
                  value: item.id,
                });
              }

              if (item.herEmail) {
                allMailcoupleList.push({
                  label: formatLabel(
                    item.herFirstName,
                    item.herLastName,
                    item.herEmail,
                  ),
                  value: item.id,
                });
              }
            });

          const sort = allcoupleList.sort((a, b) =>
            a.label.localeCompare(b.label),
          );
          setAllCoupleData(sort);

          await adminApi.outerUsers().then((outerRes) => {
            if (outerRes.success) {
              outerRes.data &&
                outerRes.data.forEach((item) => {
                  if (item.email) {
                    allMailcoupleList.push({
                      label: item.email,
                      value: item.id,
                    });
                  }
                });
              setAllCoupleMails(allMailcoupleList);
            }
          });
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const editRetreat = async (id) => {
    await retreatApi
      .getRetreatDetail({ id: id, isTemp })
      .then((res) => {
        if (res.success) {
          const retreat = res.data?.[0] || {};
          const { schedule, ...rest } = retreat;

          // Keep schedule parsing safe across possible API shapes
          const parsedScheduleRaw =
            schedule && typeof schedule === "string"
              ? JSON.parse(schedule)
              : schedule || [];

          const parsedSchedule = Array.isArray(parsedScheduleRaw)
            ? parsedScheduleRaw.map((entry) => ({
                date: entry?.date ? new Date(entry.date) : null,
                from: entry?.from,
                to: entry?.to,
              }))
            : [];

          setRetreatAdminData({
            ...rest,
            schedule: parsedSchedule,
          });
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const subAdminPopUP = (row) => {
    if (row && row.id) {
      setAdminEdiUserIdClicked(row.id);
      editRetreat(row.id);
      setCreateRetAdmin(true);
    } else {
      toast.error("Please select a retreat first.");
    }
  };

  const handlerAccessRmvShow = (item) => {
    setEditIndex(item);
    setRemoveAccessModal(true);
  };

  const handleAccessRmvClose = () => {
    setRemoveAccessModal(false);
    setEditIndex(null);
  };

  const removeAccessFromRetreat = () => {
    retreatApi
      .removeAccessFromRetreat({
        remove_access_mail: editIndex,
        retreatId: adminEdiUserIdClicked,
        isTemp: isTemp,
      })
      .then((res) => {
        toast.success(res.msg);
        // Refresh selected retreat details so modal shows updated admins.
        editRetreat(adminEdiUserIdClicked);
        handleAccessRmvClose();
      })
      .catch((error) => {
        console.error(error);
        toast.error("An error occurred while removing the administrator.");
      });
  };

  const openAddRetreatAdminPopUp = async () => {
    const id = retreatDetail?.id || retreatId;
    if (!id) {
      toast.error("Please select a retreat first.");
      return;
    }
    await getAllCouples();
    subAdminPopUP({ id });
  };

  const openAssignPopUp = async () => {
    await getTalksList();
    setTalkAssignOpen(true);
  };

  const closeAssignPopUp = () => setTalkAssignOpen(false);

  const assignTalk = async (assignments) => {
    // assignments = [{ talkId, talkName, rosterId, coupleLabel }, ...]
    // Call your API for each changed assignment
    try {
      for (const a of assignments) {
        await retreatRoastApi.updateRoasterTalk({
          rosterId: a.rosterId,
          talkId: a.talkId,
          isTemp: isTemp,
        });
      }
      toast.success("Talks assigned successfully.");
      refreshWithActiveFilter();
      getRetreatRoastData1();
    } catch (error) {
      toast.error(error.toString());
    }
  };

  const handleShowStatus = (row) => {
    setShowStatus(true);
    setAlertData(row);
  };

  const handleCloseStatus = () => {
    setShowStatus(false);
    setAlertData([]);
  };

  const retreatChangeStatus = () => {
    retreatApi
      .retreatChangeStatus({ alertData: alertData, userData: userData })
      .then((res) => {
        handleCloseStatus();
        toast.success(res.message);
        setRetreatDetail(res.data);

        toast.success(res.msg);
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const closingConfirmedCount = [
    confirmationFlag(retreatDetail, "roasterData"),
    confirmationFlag(retreatDetail, "Directory"),
    confirmationFlag(retreatDetail, "Program"),
    confirmationFlag(retreatDetail, "pictures"),
  ].filter(Boolean).length;
  const allClosingConfirmed = closingConfirmedCount === 4;
  const superAdminConfirmed = isFlagOn(retreatDetail?.confirmedByAdmin);

  return (
    <>
      <div className="rr-roster-page">
        <div className="rr-roster-header">
          <div className="rr-roster-header-left">
            <button
              type="button"
              className="rr-roster-back"
              onClick={() => navigate(-1)}
            >
              <ArrowLeft size={16} />
              Back to Manage Retreats
            </button>
            {/* <h1 className="rr-roster-title">Retreat Roster</h1> */}
            {committeeRetreatData && (
              <select
                className="rr-roster-select selectedCommRetreat"
                onChange={(e) => {
                  const retreatId = e.target.value;
                  if (retreatId)
                    navigate(`/retreatRoster?retreatId=${retreatId}`);
                }}
              >
                <option value="" className="retreatOptions">
                  Select Retreat
                </option>
                {committeeRetreatData.map((item) => (
                  <option
                    key={item.id}
                    value={item.id}
                    className="retreatOptions"
                  >
                    {`${item.title.slice(0, 30)}${
                      item.title.length > 30 ? "..." : ""
                    } ${moment(item.dateFrom)
                      .tz("America/New_York")
                      .format("MMM DD")} - ${moment(item.dateTo)
                      .tz("America/New_York")
                      .format("MMM DD")}, ${moment(item.dateFrom)
                      .tz("America/New_York")
                      .format("YYYY")}`}
                  </option>
                ))}
              </select>
            )}
            <div className="rr-roster-legend">
              <span
                className={`rr-roster-legend-item ${
                  activeFilter === "leadCouple" ? "is-active" : ""
                }`}
              >
                <span className="rr-roster-dot rr-roster-dot--lead"></span>
                <a onClick={leadCoupleData}>Lead Couple</a>
              </span>
              <span
                className={`rr-roster-legend-item ${
                  activeFilter === "spiritualMentor" ? "is-active" : ""
                }`}
              >
                <span className="rr-roster-dot rr-roster-dot--mentor"></span>
                <a onClick={spritualData}>Spiritual Mentor</a>
              </span>
              <span
                className={`rr-roster-legend-item ${
                  activeFilter === "retreatant" ? "is-active" : ""
                }`}
              >
                <span className="rr-roster-dot rr-roster-dot--retreatant"></span>
                <a onClick={RetreatData}>Retreatant</a>
              </span>
              <span
                className={`rr-roster-legend-item ${
                  activeFilter === "team" ? "is-active" : ""
                }`}
              >
                <span className="rr-roster-dot rr-roster-dot--team"></span>
                <a onClick={teamData}>Team</a>
              </span>
            </div>
          </div>
          <div className="rr-roster-header-actions">
            <button
              type="button"
              className="rr-roster-btn rr-roster-btn--ghost"
              onClick={() => training?.openGuide("retreat-roster")}
            >
              <i className="mdi mdi-play-circle-outline" aria-hidden="true" />
              Watch Guide
            </button>
            {!isTemp && userData?.userRole === "ADMIN" && (
              <>
                <button
                  type="button"
                  className="rr-roster-btn rr-roster-btn--outline sendDirectoryProgram"
                  onClick={() => openPopUpSendFile("directory")}
                >
                  <Mail size={16} />
                  Send Directory
                </button>
                <button
                  type="button"
                  className="rr-roster-btn rr-roster-btn--outline sendDirectoryProgram"
                  onClick={() => openPopUpSendFile("program")}
                >
                  <FileText size={16} />
                  Send Program
                </button>
              </>
            )}
          </div>
        </div>

        <div className="rr-roster-card">
          <div className="rr-roster-card-top">
          <div className="rr-roster-identity">
            <div className="rr-roster-identity-icon" aria-hidden="true">
              <Church size={22} />
            </div>
            <div className="rr-roster-identity-body">
              <div className="rr-roster-identity-heading">
                <h3 className="rr-roster-identity-name text-title">
                  {(() => {
                    const data = retreatRoastLeadData?.[0];
                    const hisName = [data?.hisLastName, data?.hisFirstName]
                      .filter(Boolean)
                      .join(", ");
                    const herName = data?.herFirstName || "";
                    if (hisName && herName) {
                      return `${hisName} and ${herName}`;
                    }
                    return hisName || herName || "";
                  })()}
                </h3>
              </div>
              <p className="rr-roster-identity-meta">
                <a
                  href={`/registration-retreat/${retreatDetail.id}${isTemp ? "?isTemp=true" : ""}`}
                  target="_blank"
                  title="Retreat registration link"
                >
                  {retreatDetail?.myparish?.parish ||
                    retreatDetail?.parish?.parish}
                  {retreatDetail.language
                    ? ` (${retreatDetail.language[0].toUpperCase()}${retreatDetail.language.slice(
                        1,
                      )}) `
                    : null}{" "}
                  {retreatDetail.location
                    ? `${retreatDetail.location[0].toUpperCase()}${retreatDetail.location.slice(
                        1,
                      )}`
                    : ""}
                </a>
              </p>
              <div className="rr-roster-chips-meta">
                {retreatDetail.dateFrom && retreatDetail.dateTo ? (
                  <span className="rr-roster-meta-chip">
                    <CalendarDays size={13} />
                    {moment(retreatDetail.dateFrom).isSame(
                      retreatDetail.dateTo,
                      "day",
                    )
                      ? moment(retreatDetail.dateFrom)
                          .tz("America/New_York")
                          .format("MMM D, YYYY")
                      : moment(retreatDetail.dateFrom).isSame(
                            retreatDetail.dateTo,
                            "month",
                          )
                        ? `${moment(retreatDetail.dateFrom)
                            .tz("America/New_York")
                            .format("MMM D")} - ${moment(retreatDetail.dateTo)
                            .tz("America/New_York")
                            .format("D")}, ${moment(retreatDetail.dateFrom)
                            .tz("America/New_York")
                            .format("YYYY")}`
                        : `${moment(retreatDetail.dateFrom)
                            .tz("America/New_York")
                            .format("MMM D")} - ${moment(retreatDetail.dateTo)
                            .tz("America/New_York")
                            .format("MMM D")}, ${moment(retreatDetail.dateFrom)
                            .tz("America/New_York")
                            .format("YYYY")}`}
                  </span>
                ) : null}
                <a
                  href={`/registration-retreat/${retreatDetail.id}`}
                  target="_blank"
                  title="Retreat registration link"
                  className="rr-roster-meta-chip"
                >
                  Retreat ID: {retreatDetail.id}
                </a>
                <span className="rr-roster-meta-chip">
                  Parish ID:{" "}
                  {retreatDetail?.myparish?.uniqueId ||
                    retreatDetail?.parish?.uniqueId ||
                    retreatDetail?.parishId ||
                    "N/A"}
                </span>
              </div>
            </div>
          </div>

          <div className="rr-roster-admin-row">
            {!isTemp && retreatId && !shouldHideUI ? (
              retreatDetail?.freeze === "FREEZE" ? (
                <span
                  className="rr-roster-btn rr-roster-btn--amber import_button editRetreatDisabled"
                  title="Edit Retreat"
                >
                  <Pencil size={16} />
                  Edit Retreat
                </span>
              ) : (
                <a
                  href={`/create-retreat/${retreatId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rr-roster-btn rr-roster-btn--amber import_button"
                  title="Edit Retreat"
                >
                  <Pencil size={16} />
                  Edit Retreat
                </a>
              )
            ) : null}
            <a
              onClick={() =>
                navigate(
                  `/build-my-team?retreatId=${retreatId}&isTemp=${isTemp}`,
                )
              }
              className="rr-roster-btn rr-roster-btn--blue import_button"
              title="Build My Team"
            >
              <Users size={16} />
              Build My Team
            </a>
            {!shouldHideUI && (
              <a
                onClick={openAddRetreatAdminPopUp}
                className="rr-roster-btn rr-roster-btn--green import_button"
                title="Add Retreat Administrators"
              >
                <UserPlus size={16} />
                Add Retreat Admin
              </a>
            )}
            {!shouldHideUI && (
              <a
                onClick={openAssignPopUp}
                className="rr-roster-btn rr-roster-btn--outline impbtn import_button"
              >
                <Mic2 size={16} />
                Assign Talks
              </a>
            )}
            {!isTemp &&
            (userData.email === "jimmieflores@gmail.com" ||
              userData.email === "manpreet02701@gmail.com" ||
              userData.email === "kolkebeckd@gmail.com") ? (
              <span
                className={`default closeMail rr-roster-btn rr-roster-btn--purple ${
                  isRetreatClosed || superAdminConfirmed
                    ? "closeRet close_color_on is-confirmed"
                    : "reOpenRet close_color_off"
                }`}
                onClick={
                  isRetreatClosed || superAdminConfirmed
                    ? undefined
                    : openSendMailAlert
                }
                aria-disabled={isRetreatClosed || superAdminConfirmed}
              >
                <a>
                  {isRetreatClosed || superAdminConfirmed
                    ? "Retreat Confirmed by Super-Admin"
                    : "Retreat Confirm by Super-Admin"}
                </a>
              </span>
            ) : null}
            {userData?.access === true &&
              userData?.userRole !== "ADMIN" &&
              userData?.isDisabled === 0 &&
              !shouldHideUI && (
                <div className="rr-roster-status-toggle checkStatus">
                  <span>Activate/ Deactivate Retreat</span>
                  <Form.Check
                    className={`switchSize ${
                      retreatDetail.status === "ACTIVE"
                        ? "toggle-on-status"
                        : "toggle-off-status switchColor"
                    }`}
                    type="checkBox"
                    name="status"
                    value={retreatDetail.status}
                    checked={retreatDetail.status === "ACTIVE"}
                    onChange={() => handleShowStatus(retreatDetail)}
                    id="status"
                  />
                </div>
              )}
          </div>
          </div>

          {!isTemp && (
            <div
              className={`rr-roster-checklist${checklistOpen ? " is-open" : ""}`}
            >
              <button
                type="button"
                className="rr-roster-checklist-toggle"
                aria-expanded={checklistOpen}
                onClick={() => setChecklistOpen((open) => !open)}
              >
                <span className="rr-roster-checklist-label">
                  Closing checklist
                  <span className="rr-roster-checklist-count">
                    {closingConfirmedCount}/4 confirmed
                  </span>
                </span>
                <span className="rr-roster-checklist-chevron">
                  <ChevronDown
                    size={18}
                    className={checklistOpen ? "is-open" : ""}
                  />
                </span>
              </button>
              {checklistOpen && (
                <div className="rr-roster-confirmations">
                  <p className="rr-roster-confirm-hint">
                    Confirm each item below, even if some data is still
                    pending. Closing the Retreat unlocks after all four are
                    confirmed.
                  </p>
                  <div className="rr-roster-confirm-row">
                  <Confirmations
                    missingDataLength={missingRosterFieldsLength}
                    retreatRoastData={allRoasters}
                    retreatHeading={retreatDetail}
                    handleConfirmStatus={getRetreatDetail}
                    userData={userData}
                  />
                  {userData && userData.userRole === "ADMIN" ? (
                    <div
                      className={`rr-roster-close-switch status_btn ${
                        allClosingConfirmed ? "is-ready" : "is-locked"
                      }`}
                    >
                      <Form.Check
                        disabled={!allClosingConfirmed}
                        className={`switchSize confirm-toggle mb-0 ${
                          Boolean(retreatDetail?.retreatCloseStatus)
                            ? "toggle-on marginToggle"
                            : "retreat-close-toggle-off"
                        }`}
                        type="switch"
                        id="retreatCloseStatus"
                        checked={Boolean(retreatDetail?.retreatCloseStatus)}
                        onChange={openStatusAlert}
                      />
                      <div>
                        <h6
                          className={`default mb-0 ${
                            Boolean(retreatDetail?.retreatCloseStatus)
                              ? "closeRet  close_color_on"
                              : "reOpenRet close_color_off"
                          }`}
                        >
                          <a>Retreat Validated and Closed</a>
                        </h6>
                        {!allClosingConfirmed ? (
                          <span className="rr-roster-close-note">
                            Locked until all four confirmations are on
                          </span>
                        ) : (
                          <span className="rr-roster-close-note is-ready">
                            All confirmations complete â€” you can close this
                            Retreat
                          </span>
                        )}
                      </div>
                    </div>
                  ) : null}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="rr-roster-tools">
          <div className="rr-roster-toolbar">
            {renderMissingDataLegend()}
            <div className="rr-roster-search">
              <Search size={16} />
              <input
                onChange={SearchData}
                value={searchKey}
                type="text"
                className="form-control searchData"
                placeholder="Search roster..."
                aria-label="Search roster"
              />
            </div>
            <div className="rr-roster-file-group" role="group" aria-label="Roster files">
              {!shouldHideUI && (
                <a
                  onClick={downloadSampleExcel}
                  className="rr-roster-btn rr-roster-btn--ghost set_text"
                  title="Download Sample Excel"
                >
                  <Download size={15} />
                  Sample
                </a>
              )}
              {((retreatDetail && retreatDetail.freeze === "UNFREEZE") ||
                isTemp) &&
              !shouldHideUI ? (
                <>
                  <a
                    onClick={clickOnInputFile}
                    className="rr-roster-btn rr-roster-btn--ghost impbtn import_button"
                  >
                    <Upload size={16} />
                    Import
                  </a>
                  <input
                    className="btn btn-secondary"
                    type="file"
                    name="File Upload"
                    id="fileUpload"
                    hidden
                    onChange={fileChangeListener}
                    accept=".xlsx"
                  />
                </>
              ) : !shouldHideUI ? (
                <span
                  className={`rr-roster-btn rr-roster-btn--ghost ${
                    retreatDetail && retreatDetail.freeze === "FREEZE"
                      ? "exportHover"
                      : ""
                  } impbtn import_button`}
                >
                  <Upload size={16} />
                  Import
                </span>
              ) : null}
              <Dropdown>
                <Dropdown.Toggle
                  className="rr-roster-btn rr-roster-btn--primary"
                  id="dropdown-basic"
                >
                  <Download size={16} />
                  Export
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item onClick={() => exportByTypeExcel("Retreatant")}>
                    Export by Retreatant (Excel)
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => exportByTypePdf("Retreatant")}>
                    Export by Retreatant (PDF)
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => exportByTypeExcel("Team")}>
                    Export by Team (Excel)
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => exportByTypePdf("Team")}>
                    Export by Team (PDF)
                  </Dropdown.Item>
                  <Dropdown.Item onClick={exportFlockNotes}>
                    Flock Note Excel
                  </Dropdown.Item>
                  <Dropdown.Item onClick={handleExport}>
                    All data (Excel)
                  </Dropdown.Item>
                  <Dropdown.Item onClick={exportPdf}>
                    All data (PDF)
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            {retreatDetail.freeze === "UNFREEZE" && !shouldHideUI ? (
              <button
                className="rr-roster-btn rr-roster-btn--icon add-user newroaster"
                type="button"
                title="Add New Couple"
                onClick={() => {
                  addRoaster();
                }}
              >
                <UserPlus size={18} />
              </button>
            ) : null}
          </div>
          {(userData && userData.userRole === "ADMIN") ||
          (userData && userData.committeeMember === true) ||
          (userData &&
            userData.userRole !== "ADMIN" &&
            userData.access === true) ? (
            <div className="roster-filter-bar">
              <div className="roster-filter-chips">
                {renderRosterFilterChip(
                  "Team",
                  "team",
                  team_count,
                  activeFilter === "team",
                  teamData,
                  false,
                  {
                    icon: "mdi mdi-account-group-outline",
                    title: "Assign Team Couple",
                    onClick: () =>
                      setFilterActionModal({
                        open: true,
                        filterType: "team",
                        label: "Team",
                      }),
                  },
                )}
                {renderRosterFilterChip(
                  "Lead Couple",
                  "leadCouple",
                  lead_count,
                  activeFilter === "leadCouple",
                  leadCoupleData,
                  false,
                  {
                    icon: "mdi mdi-account-star-outline",
                    title: "Assign Lead Couple",
                    onClick: () =>
                      setFilterActionModal({
                        open: true,
                        filterType: "leadCouple",
                        label: "Lead Couple",
                      }),
                  },
                )}
                {renderRosterFilterChip(
                  "Retreatant",
                  "retreatant",
                  ret_count,
                  activeFilter === "retreatant",
                  RetreatData,
                  false,
                  {
                    icon: "mdi mdi-account-heart-outline",
                    title: "Assign Retreatant Couple",
                    onClick: () =>
                      setFilterActionModal({
                        open: true,
                        filterType: "retreatant",
                        label: "Retreatant",
                      }),
                  },
                )}
                {renderRosterFilterChip(
                  "Spiritual Mentor",
                  "spiritualMentor",
                  spritual_count,
                  activeFilter === "spiritualMentor",
                  spritualData,
                  false,
                  {
                    icon: "mdi mdi-account-supervisor",
                    title: "Assign Spiritual Mentor",
                    onClick: () =>
                      setFilterActionModal({
                        open: true,
                        filterType: "spiritualMentor",
                        label: "Spiritual Mentor",
                      }),
                  },
                )}
                {renderRosterFilterChip(
                  "Spiritual Director",
                  "spiritualDirector",
                  spritualDirector_count,
                  false,
                  openSpiritualDirector,
                  spritualDirector_count === 0,
                  {
                    icon:
                      spritualDirector_count > 0
                        ? "mdi mdi-pencil-outline"
                        : "mdi mdi-account-plus-outline",
                    title:
                      spritualDirector_count > 0
                        ? "Edit Spiritual Director (Priest)"
                        : "Assign Spiritual Director (Priest)",
                    onClick: () =>
                      setFilterActionModal({
                        open: true,
                        filterType: "spiritualDirector",
                        label: "Spiritual Director",
                      }),
                  },
                )}
                {renderRosterFilterChip(
                  "Services",
                  "service",
                  service_count,
                  activeFilter === "service",
                  serviceData,
                  false,
                  {
                    icon: "mdi mdi-wrench-outline",
                    title: "Assign Services",
                    onClick: () =>
                      setFilterActionModal({
                        open: true,
                        filterType: "service",
                        label: "Services",
                      }),
                  },
                )}
                {renderRosterFilterChip(
                  "Talks",
                  "talk",
                  talk_count,
                  activeFilter === "talk",
                  talkData,
                  false,
                  {
                    icon: "mdi mdi-microphone-outline",
                    title: "Assign Talks",
                    onClick: openAssignPopUp,
                  },
                )}
                {renderRosterFilterChip(
                  "RTP",
                  "rtp",
                  rtp_count,
                  activeFilter === "rtp",
                  rtpData,
                  false,
                  {
                    icon: "mdi mdi-heart-circle-outline",
                    title: "Assign RTP Couple",
                    onClick: () =>
                      setFilterActionModal({
                        open: true,
                        filterType: "rtp",
                        label: "RTP",
                      }),
                  },
                )}
                  <button
                  className="roster-chip-clear"
                  onClick={clearFilter}
                >
                  Clear filter
                </button>
              </div>
            </div>
          ) : null}
        </div>

        <div className="card custom-card rr-roster-table-card">
          <CustomDataTable
            key={`table-${activeFilter || "all"}-${resetKey}-${retreatDetail?.retreatCloseStatus}`}
            loading={LoadData}
            data={retreatRoastData}
            countPerPage={20}
            isServerSide={!missingValue}
            pagination={true}
            sortServer={!missingValue}
            total={total}
            columns={columns}
            dataFetchApi={getRetreatRoastData}
            selectedRetreat={activeFilter}
            pointerOnHover={true}
            highlightOnHover={true}
          />
        </div>

        <div className="rr-roster-docs">
          <h4 className="rr-roster-docs-title">Documents</h4>
          <div className="rr-roster-docs-grid">
            <div className="rr-roster-docs-left left-section">
              {!isTemp && !shouldHideUI && (
                <div className="rr-roster-docs-item item">
                  <a href={`/create-program/${retreatId}`} target="_blank">
                    <button className="dirProgButtons">Create Program</button>
                  </a>
                  {retreatDetail.programStatus === "PUBLISH" && (
                    <a
                      href={`/program/${retreatId}`}
                      target="_blank"
                      className="view-link"
                    >
                      View Program
                    </a>
                  )}
                </div>
              )}
              {!isTemp && !shouldHideUI && (
                <div className="rr-roster-docs-item item">
                  <a href={`/create-directory/${retreatId}`} target="_blank">
                    <button className="dirProgButtons">Create Directory</button>
                  </a>
                  {retreatDetail.directoryStatus === "PUBLISH" && (
                    <a
                      href={`/directory/${retreatId}`}
                      target="_blank"
                      className="view-link"
                    >
                      View Directory
                    </a>
                  )}
                </div>
              )}
            </div>
            <div className="rr-roster-docs-right right-section font-size">
              <div className="icon-group">
                <span className="icon-label" title="Upload Directory File">
                  DIRECTORY:
                </span>
                {retreatDetail.freeze === "FREEZE" ? (
                  <div
                    className={`action-icons ${
                      retreatDetail.directoryFile ? "editRetreatDisabled" : ""
                    } editRetreatDisabled`}
                  >
                    <i className="mdi mdi-folder-open" title="Upload Directory"></i>
                    {retreatDetail.directoryFile && (
                      <a
                        href={retreatDetail.directoryFile}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i
                          title="Download Directory"
                          className="mdi mdi-download"
                          style={{ color: "#4cd964" }}
                        ></i>
                      </a>
                    )}
                  </div>
                ) : (
                  <div className="action-icons">
                    <i
                      className="mdi mdi-folder-open"
                      title="Upload Directory"
                      onClick={(e) => {
                        e.preventDefault();
                        handleUploadDirectory(retreatDetail);
                      }}
                    ></i>
                    {retreatDetail.directoryFile && (
                      <a
                        href={retreatDetail.directoryFile}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i
                          title="Download Directory"
                          className="mdi mdi-download"
                          style={{ color: "#4cd964" }}
                        ></i>
                      </a>
                    )}
                  </div>
                )}
              </div>
              <div className="icon-group">
                <span className="icon-label" title="Upload Program File">
                  PROGRAM:
                </span>
                {retreatDetail.freeze === "FREEZE" ? (
                  <div className="action-icons editRetreatDisabled">
                    <i
                      className="mdi mdi-calendar-multiselect"
                      title="Upload Program"
                    ></i>
                    {retreatDetail.programFile && (
                      <a
                        href={retreatDetail.programFile}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i
                          title="Download Program"
                          className="mdi mdi-download"
                          style={{ color: "#4cd964" }}
                        ></i>
                      </a>
                    )}
                  </div>
                ) : (
                  <div className="action-icons">
                    <i
                      className="mdi mdi-calendar-multiselect"
                      title="Upload Program"
                      onClick={(e) => {
                        e.preventDefault();
                        handleUploadProgram(retreatDetail);
                      }}
                    ></i>
                    {retreatDetail.programFile && (
                      <a
                        href={retreatDetail.programFile}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i
                          title="Download Program"
                          className="mdi mdi-download"
                          style={{ color: "#4cd964" }}
                        ></i>
                      </a>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
        {showRegModal ? (
          <UpdateCouplePopUp
            showRegModal={showRegModal}
            setShowREgModal={setShowREgModal}
            setEdiUserIdClicked={setEdiUserIdClicked}
            onHide={() => {
              CloseCompose();
              clearfield();
              setEdiUserIdClicked("");
            }}
            closeButton={() => {
              checkPKCouple();
              setEdiUserIdClicked("");
              CloseCompose();
              refreshWithActiveFilter();
            }}
            userData={userData}
            isEditAdmin={isEditAdmin}
            parishList={parishList}
            setParishList={setParishList}
            ediUserIdClicked={ediUserIdClicked}
            CloseCompose={CloseCompose}
            roasterCount={roasterCount}
            roastersOfCoupleList={roastersOfCoupleList}
            refreshRoastersOfCouple={getroastersOfCouple}
            getAllCouples={getRetreatRoastData}
            data={data}
            setData={setData}
            oldValues={oldValues}
            setOldValues={setOldValues}
            isTempUpload={isTempUpload}
            // isTempUpload2={isTempUpload2}
            setIsTempUpload={setIsTempUpload}
            retreatDetail={retreatDetail}
            // setIsTempUpload2={setIsTempUpload2}
          />
        ) : null}
        {showModel ? renderEditRetreatModel() : null}
        {statusCheck ? (
          <AlertModal
            show={statusCheck}
            handleClose={closeStatusAlert}
            message={`Are you sure you want to ${
              Boolean(retreatDetail?.retreatCloseStatus) ? "reopen" : "close"
            } this retreat?`}
            actionFunction={retreatClose}
            cancel={"Cancel"}
            okay={"Okay"}
            heading={"ALERT!!"}
          />
        ) : null}

        {mailSendStatus ? (
          <AlertModal
            appearance="confirm"
            show={mailSendStatus}
            handleClose={closeSendMailAlert}
            message={`Are you sure you want to confirm "${
              retreatDetail?.myparish?.parish || ""
            }${
              retreatDetail?.language
                ? ` (${retreatDetail.language[0].toUpperCase()}${retreatDetail.language.slice(1)})`
                : ""
            }${
              retreatDetail?.location
                ? ` ${retreatDetail.location[0].toUpperCase()}${retreatDetail.location.slice(1)}`
                : ""
            }" Retreat? Confirming marks Roster Data, Directory, Program, and Pictures as confirmed and closes this Retreat, even when older data is incomplete.`}
            actionFunction={mailSend}
            cancel={"Cancel"}
            okay={"Confirm retreat"}
            heading={"Confirm retreat"}
          />
        ) : null}

        <DeleteModel
          show={show}
          content={
            <>
              <h5 className="mt-4 fw-bold">Couple Detail</h5>
              <div className="p-3 border rounded-3 bg-light shadow-sm">
                {/* His Details */}
                {(roast_id.hisFirstName ||
                  roast_id.hisLastName ||
                  roast_id.hisEmail) && (
                  <div className="mb-2">
                    <span className="fw-bold">His:</span>{" "}
                    {roast_id.hisFirstName} {roast_id.hisLastName}
                    {roast_id.hisEmail && (
                      <span className="text-muted"> â€“ {roast_id.hisEmail}</span>
                    )}
                  </div>
                )}

                {/* Her Details */}
                {(roast_id.herFirstName ||
                  roast_id.herLastName ||
                  roast_id.herEmail) && (
                  <div>
                    <span className="fw-bold">Her:</span>{" "}
                    {roast_id.herFirstName} {roast_id.herLastName}
                    {roast_id.herEmail && (
                      <span className="text-muted"> â€“ {roast_id.herEmail}</span>
                    )}
                  </div>
                )}
              </div>
            </>
          }
          handleClose={handleClose}
          DeleteData={DeleteData}
        ></DeleteModel>
        <FileUploadModal
          show={showUploadModal}
          handleClose={handleUploadModalClose}
          rowId={selectedRowId}
          handleUploadSuccess={handleUploadSuccess}
          fileType={fileType}
          onDeleteFile={handleDeleteFile}
          existingFileUrl={existingFileUrl}
          modalTitle={uploadModalTitle}
          userData={userData}
        />
        <OtherParishModal
          show={otherParishModalOpen}
          handleClose={() => setOtherParishModalOpen(false)}
          registerationData={roasterdData}
          setRegisterationData={setRoasterdData}
          setParishList={setParishList}
          parishList={parishList}
        />
        {sendFile && (
          <SendFileModal
            show={sendFile}
            handleClose={closePopUpSendFile}
            onSend={sendDirProgFile}
            loader={fileSendLoader}
            retreatRoastData={retreatRoastData}
            fileType={sendFileType}
          />
        )}

        {/* â”€â”€ "Add Retreat Administrators" modal â”€â”€ */}
        {removeAccessModal ? (
          <DeleteModel
            show={removeAccessModal}
            content={
              <>
                <h5 className="mt-4 fw-bold">Remove Retreat Administrator</h5>
                <div className="p-3 border rounded-3 bg-light shadow-sm">
                  <div className="mb-2">
                    <span className="fw-bold">Administrator:</span>{" "}
                    <span className="text-muted">{editIndex}</span>
                  </div>
                </div>
              </>
            }
            handleClose={handleAccessRmvClose}
            DeleteData={removeAccessFromRetreat}
          />
        ) : null}

        {createRetAdmin ? (
          <CreateRetreatSubAdmin
            show={createRetAdmin}
            alertHeader={"Add Retreat Administrators"}
            alerMessage={""}
            allCoupleMails={allCoupleMails}
            allCoupleData={allCoupleData}
            ediUserIdClicked={adminEdiUserIdClicked}
            data={retreatAdminData}
            handlerAccessRmvShow={handlerAccessRmvShow}
            editRetreat={editRetreat}
            isTemp={isTemp}
            getAllCouples={getAllCouples}
            handleClose={() => {
              setCreateRetAdmin(false);
              setAdminEdiUserIdClicked("");
              setRetreatAdminData({ userEmails: [] });
              // Reflect changes in the visible table.
              refreshWithActiveFilter();
              getRetreatRoastData1();
            }}
          />
        ) : null}

        {talkAssignOpen && (
          <AssignTalkModal
            show={talkAssignOpen}
            handleClose={closeAssignPopUp}
            allRoasters={allRoasters}
            talksDataList={talksDataList}
            retreatRoastApi={retreatRoastApi}
            retreatId={retreatId}
            isTemp={isTemp}
            spritualDirector={spritualDirector}
            onAssignSuccess={() => {
              getRetreatRoastData1(); // refreshes counts + allRoasters
              refreshWithActiveFilter(); // refreshes the visible table
              spritualDirectorData();
            }}
          />
        )}

        {filterActionModal.open && (
          <RosterFilterActionModal
            show={filterActionModal.open}
            handleClose={() =>
              setFilterActionModal({
                open: false,
                filterType: null,
                label: "",
              })
            }
            filterType={filterActionModal.filterType}
            label={filterActionModal.label}
            retreatId={retreatId}
            isTemp={isTemp}
            allRoasters={allRoasters}
            allCoupleData={allCoupleData}
            serviceDataList={serviceDataList}
            retreatRoastApi={retreatRoastApi}
            serviceApi={serviceApi}
            spritualDirector={spritualDirector}
            parishList={parishList}
            setParishList={setParishList}
            userData={userData}
            retreatDetail={retreatDetail}
            onRefreshCouples={getAllCouples}
            onRefreshServices={getServiceList}
            onSuccess={() => {
              getRetreatRoastData1();
              refreshWithActiveFilter();
              spritualDirectorData();
              leadCoupleData1();
              getCouplesInRetreat();
            }}
          />
        )}

        <Modal
          show={copyMailOpen}
          onHide={() => setCopyMailOpen(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{copyMailTitle} emails</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex align-items-center justify-content-between mb-5">
              <span className="mt-1">Copy all addresses, separated by commas.</span>
              <Button className="mt-1"
                size="sm"
                variant="primary"
                onClick={() => {
                  navigator.clipboard
                    .writeText(copyMailList.join(", "))
                    .then(() => toast.success("Copied to clipboard!"))
                    .catch(() => toast.error("Could not copy."));
                  setCopyMailOpen(false);
                }}
              >
                Copy all
              </Button>
            </div>
            {copyMailList.map((email) => (
              <div
                key={email}
                className="d-flex align-items-center justify-content-between border-bottom py-2"
              >
                <span>{email}</span>
                <CopyIcon
                  text={email}
                  onCopy={() => setCopyMailOpen(false)}
                />
              </div>
            ))}
          </Modal.Body>
        </Modal>

        <Modal
          show={priestStatus}
          onHide={closePriestAlert}
          centered
          className="ram-modal"
          dialogClassName="ram-dialog ram-dialog-director"
          contentClassName="ram-content"
        >
          <div className="ram-shell">
            <header className="ram-header">
              <div className="ram-mark ram-mark--violet" aria-hidden="true">
                <Church size={20} />
              </div>
              <div className="ram-header-copy">
                <p className="ram-kicker">Retreat roster</p>
                <h2>Spiritual Director (Priest)</h2>
                <p>Assigned priest for this retreat.</p>
              </div>
              <button
                type="button"
                className="ram-close"
                onClick={closePriestAlert}
                aria-label="Close"
              >
                <X size={18} />
              </button>
            </header>
            <div className="ram-body">
              {priestLoading ? (
                <div
                  className="ram-loading"
                  role="status"
                  aria-live="polite"
                  aria-label="Loading spiritual director"
                >
                  <span className="ram-director-spinner" />
                </div>
              ) : spritualDirector ? (
                <div className="ram-director-card">
                  <div className="ram-director-hero">
                    {typeof spritualDirector.imageUrl === "string" &&
                    spritualDirector.imageUrl.trim() ? (
                      <img
                        className="ram-director-avatar"
                        src={spritualDirector.imageUrl}
                        alt=""
                        onError={(event) => {
                          event.currentTarget.onerror = null;
                          event.currentTarget.src = corruptedImg;
                        }}
                      />
                    ) : (
                      <div className="ram-director-avatar" aria-hidden="true">
                        {[spritualDirector.firstName, spritualDirector.lastName]
                          .map((part) => String(part || "").trim().charAt(0))
                          .join("")
                          .toUpperCase() || <Church size={22} />}
                      </div>
                    )}
                    <div className="ram-director-identity">
                      <p className="ram-director-name">
                        {[
                          spritualDirector.title,
                          spritualDirector.firstName,
                          spritualDirector.lastName,
                        ]
                          .map((part) => String(part || "").trim())
                          .filter(Boolean)
                          .join(" ") || "Unnamed priest"}
                      </p>
                      <p className="ram-director-parish">
                        <Church size={14} aria-hidden="true" />
                        {spritualDirector?.parish?.parish || "Parish not provided"}
                      </p>
                      {spritualDirector.primaryKey ? (
                        <span className="ram-director-id">
                          Priest ID {spritualDirector.primaryKey}
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <div className="ram-director-grid">
                    <DirectorField label="Email" wide>
                      {spritualDirector.email ? (
                        <span className="ram-director-email">
                          <a href={`mailto:${spritualDirector.email}`}>
                            {spritualDirector.email}
                          </a>
                          <CopyIcon text={spritualDirector.email} />
                        </span>
                      ) : (
                        directorText("")
                      )}
                    </DirectorField>
                    <DirectorField label="Address" wide>
                      {directorText(spritualDirector.address)}
                    </DirectorField>
                    <DirectorField label="City">
                      {directorText(spritualDirector.city)}
                    </DirectorField>
                    <DirectorField label="State">
                      {directorText(spritualDirector.state)}
                    </DirectorField>
                    <DirectorField label="Zip">
                      {directorText(spritualDirector.zip)}
                    </DirectorField>
                    {spritualDirector.talk?.talk ? (
                      <DirectorField label="Assigned talk">
                        {spritualDirector.talk.talk}
                      </DirectorField>
                    ) : null}
                  </div>
                </div>
              ) : (
                <div className="ram-director-empty">
                  <Church size={22} aria-hidden="true" />
                  <strong>Not assigned</strong>
                  <p>No spiritual director is assigned to this retreat.</p>
                </div>
              )}
            </div>
            <footer className="ram-footer">
              <button
                type="button"
                className="ram-btn ram-btn-primary ram-btn-violet"
                onClick={closePriestAlert}
              >
                Close
              </button>
            </footer>
          </div>
        </Modal>

        {showStatus ? (
          <AlertModal
            show={showStatus}
            handleClose={handleCloseStatus}
            message={`Are you sure you want to ${
              alertData.status === "ACTIVE" ? "INACTIVE" : "ACTIVE"
            } this retreat?`}
            actionFunction={retreatChangeStatus}
            cancel={"Cancel"}
            okay={"Okay"}
            heading={"ALERT!!"}
          />
        ) : null}
    </>
  );
};

export default RetreatRoaster;
